function PlanI({ ...props }) {
	return (
		<g {...props} id="unit-i">
			<g id="furniture">
				<polyline
					points="651.98 835.21 651.98 829.68 654.78 829.68 654.78 835.21 651.98 835.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="326.8"
					y1="384.68"
					x2="203.86"
					y2="384.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.8"
					y1="422.22"
					x2="326.8"
					y2="384.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.13"
					y1="422.22"
					x2="273.14"
					y2="422.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.74"
					y1="422.22"
					x2="282.75"
					y2="422.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.35"
					y1="422.22"
					x2="292.36"
					y2="422.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="295.96"
					y1="422.22"
					x2="301.97"
					y2="422.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.58"
					y1="422.22"
					x2="311.58"
					y2="422.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.19"
					y1="422.22"
					x2="321.19"
					y2="422.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.8"
					y1="422.22"
					x2="326.8"
					y2="422.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.8"
					y1="422.22"
					x2="326.8"
					y2="416.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.8"
					y1="412.51"
					x2="326.8"
					y2="406.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.8"
					y1="402.9"
					x2="326.8"
					y2="396.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.8"
					y1="393.29"
					x2="326.8"
					y2="387.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.8"
					y1="387.18"
					x2="324.8"
					y2="387.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="321.19"
					y1="387.18"
					x2="315.19"
					y2="387.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.58"
					y1="387.18"
					x2="305.58"
					y2="387.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="301.97"
					y1="387.18"
					x2="295.96"
					y2="387.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="292.36"
					y1="387.18"
					x2="286.35"
					y2="387.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.75"
					y1="387.18"
					x2="276.74"
					y2="387.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.14"
					y1="387.18"
					x2="267.13"
					y2="387.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.53"
					y1="387.18"
					x2="257.52"
					y2="387.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.92"
					y1="387.18"
					x2="247.91"
					y2="387.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.31"
					y1="387.18"
					x2="238.3"
					y2="387.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.7"
					y1="387.18"
					x2="228.69"
					y2="387.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.09"
					y1="387.18"
					x2="219.08"
					y2="387.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.47"
					y1="387.18"
					x2="209.47"
					y2="387.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.86"
					y1="387.18"
					x2="203.86"
					y2="387.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.86"
					y1="387.18"
					x2="203.86"
					y2="393.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.86"
					y1="396.9"
					x2="203.86"
					y2="402.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.86"
					y1="406.5"
					x2="203.86"
					y2="412.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.19"
					y1="604.63"
					x2="706.19"
					y2="844.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.19"
					y1="844.19"
					x2="657.57"
					y2="844.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="874.23"
					x2="732.34"
					y2="874.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.74"
					y1="874.23"
					x2="722.73"
					y2="874.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.13"
					y1="874.23"
					x2="713.12"
					y2="874.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.51"
					y1="874.23"
					x2="703.51"
					y2="874.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.91"
					y1="874.23"
					x2="693.9"
					y2="874.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.29"
					y1="874.23"
					x2="684.29"
					y2="874.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.68"
					y1="874.23"
					x2="674.67"
					y2="874.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.07"
					y1="874.23"
					x2="665.07"
					y2="874.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="661.46"
					y1="874.23"
					x2="657.57"
					y2="874.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="413.96 888.18 352.12 888.18 352.12 826.34 413.96 826.34 413.96 888.18"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="352.11 55.01 352.11 57.51 250.04 57.51 250.04 55.01 352.11 55.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="352.11"
					y1="55.01"
					x2="352.11"
					y2="57.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.11"
					y1="57.51"
					x2="250.04"
					y2="57.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="250.04"
					y1="57.51"
					x2="250.04"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="250.04"
					y1="55.01"
					x2="352.11"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="402.99 54.02 361.02 54.02 361.02 59.44 402.99 59.44 402.99 54.02"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="359.05 53.53 404.96 53.53 404.96 54.02 359.05 54.02 359.05 53.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="359.05"
					y1="53.53"
					x2="404.96"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="404.96"
					y1="53.53"
					x2="404.96"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="404.96"
					y1="54.02"
					x2="359.05"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.05"
					y1="54.02"
					x2="359.05"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.99"
					y1="59.44"
					x2="361.02"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361.02"
					y1="54.02"
					x2="402.99"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="407.43 59.44 402.99 59.44 402.99 54.02 407.43 54.02 407.43 59.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="407.43"
					y1="59.44"
					x2="402.99"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.99"
					y1="59.44"
					x2="402.99"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.99"
					y1="54.02"
					x2="407.43"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.43"
					y1="54.02"
					x2="407.43"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="356.59 54.02 361.02 54.02 361.02 59.44 356.59 59.44 356.59 54.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="356.59"
					y1="54.02"
					x2="361.02"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361.02"
					y1="54.02"
					x2="361.02"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361.02"
					y1="59.44"
					x2="356.59"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.59"
					y1="59.44"
					x2="356.59"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.99"
					y1="55.01"
					x2="361.02"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="409.4 58.95 407.43 58.95 407.43 54.02 404.96 54.02 404.96 53.53 409.4 53.53 409.4 58.95"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="409.4"
					y1="58.95"
					x2="407.43"
					y2="58.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.43"
					y1="58.95"
					x2="407.43"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.43"
					y1="54.02"
					x2="404.96"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="404.96"
					y1="54.02"
					x2="404.96"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="404.96"
					y1="53.53"
					x2="409.4"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.4"
					y1="53.53"
					x2="409.4"
					y2="58.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="354.61 53.53 359.05 53.53 359.05 54.02 356.59 54.02 356.59 58.95 354.61 58.95 354.61 53.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="354.61"
					y1="53.53"
					x2="359.05"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.05"
					y1="53.53"
					x2="359.05"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.05"
					y1="54.02"
					x2="356.59"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.59"
					y1="54.02"
					x2="356.59"
					y2="58.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.59"
					y1="58.95"
					x2="354.61"
					y2="58.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.61"
					y1="58.95"
					x2="354.61"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="349.61 55.01 354.61 55.01 354.61 70.02 349.61 70.02 349.61 55.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="354.61"
					y1="55.01"
					x2="349.61"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.61"
					y1="70.02"
					x2="354.61"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.61"
					y1="70.02"
					x2="354.61"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.61"
					y1="55.01"
					x2="349.61"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="414.4 55.01 414.4 70.02 409.4 70.02 409.4 55.01 414.4 55.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="414.4"
					y1="70.02"
					x2="414.4"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.4"
					y1="70.02"
					x2="414.4"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.4"
					y1="55.01"
					x2="409.4"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414.4"
					y1="55.01"
					x2="409.4"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="247.54 55.01 252.55 55.01 252.55 70.02 247.54 70.02 247.54 55.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="252.55"
					y1="55.01"
					x2="247.54"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="252.55"
					y1="70.02"
					x2="252.55"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.54"
					y1="70.02"
					x2="252.55"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.54"
					y1="55.01"
					x2="247.54"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="681.93 55.01 681.93 57.51 549.92 57.51 549.92 55.01 681.93 55.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="681.93"
					y1="55.01"
					x2="681.93"
					y2="57.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="681.93"
					y1="57.51"
					x2="549.92"
					y2="57.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.92"
					y1="57.51"
					x2="549.92"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.92"
					y1="55.01"
					x2="681.93"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="732.13 54.02 690.84 54.02 690.84 59.44 732.13 59.44 732.13 54.02"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="688.87 53.53 734.1 53.53 734.1 54.02 688.87 54.02 688.87 53.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="688.87"
					y1="53.53"
					x2="734.1"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.1"
					y1="53.53"
					x2="734.1"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.1"
					y1="54.02"
					x2="688.87"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.87"
					y1="54.02"
					x2="688.87"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.13"
					y1="59.44"
					x2="690.84"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.84"
					y1="54.02"
					x2="732.13"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="736.56 59.44 732.13 59.44 732.13 54.02 736.56 54.02 736.56 59.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="736.56"
					y1="59.44"
					x2="732.13"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.13"
					y1="59.44"
					x2="732.13"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.13"
					y1="54.02"
					x2="736.56"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.56"
					y1="54.02"
					x2="736.56"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="686.4 54.02 690.84 54.02 690.84 59.44 686.4 59.44 686.4 54.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="686.4"
					y1="54.02"
					x2="690.84"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.84"
					y1="54.02"
					x2="690.84"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.84"
					y1="59.44"
					x2="686.4"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.4"
					y1="59.44"
					x2="686.4"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.13"
					y1="55.01"
					x2="690.84"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="738.54 58.95 736.56 58.95 736.56 54.02 734.1 54.02 734.1 53.53 738.54 53.53 738.54 58.95"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="738.54"
					y1="58.95"
					x2="736.56"
					y2="58.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.56"
					y1="58.95"
					x2="736.56"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.56"
					y1="54.02"
					x2="734.1"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.1"
					y1="54.02"
					x2="734.1"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.1"
					y1="53.53"
					x2="738.54"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.54"
					y1="53.53"
					x2="738.54"
					y2="58.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="684.43 53.53 688.87 53.53 688.87 54.02 686.4 54.02 686.4 58.95 684.43 58.95 684.43 53.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="684.43"
					y1="53.53"
					x2="688.87"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.87"
					y1="53.53"
					x2="688.87"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.87"
					y1="54.02"
					x2="686.4"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.4"
					y1="54.02"
					x2="686.4"
					y2="58.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.4"
					y1="58.95"
					x2="684.43"
					y2="58.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="684.43"
					y1="58.95"
					x2="684.43"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="679.42 55.01 684.43 55.01 684.43 70.02 679.42 70.02 679.42 55.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="684.43"
					y1="55.01"
					x2="679.42"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="684.43"
					y1="70.02"
					x2="684.43"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.42"
					y1="70.02"
					x2="684.43"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.42"
					y1="55.01"
					x2="679.42"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="743.54 55.01 743.54 70.02 738.54 70.02 738.54 55.01 743.54 55.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="743.54"
					y1="70.02"
					x2="743.54"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.54"
					y1="70.02"
					x2="743.54"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.54"
					y1="55.01"
					x2="738.54"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.54"
					y1="55.01"
					x2="738.54"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="547.41 55.01 552.42 55.01 552.42 70.02 547.41 70.02 547.41 55.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="552.42"
					y1="55.01"
					x2="547.41"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.42"
					y1="70.02"
					x2="552.42"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.41"
					y1="70.02"
					x2="552.42"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.41"
					y1="55.01"
					x2="547.41"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.54"
					y1="50"
					x2="743.54"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="338.66"
					y1="897.56"
					x2="338.66"
					y2="816.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="434.79"
					y1="948.75"
					x2="431.03"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="434.79"
					y1="928.73"
					x2="431.03"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="434.79"
					y1="928.73"
					x2="434.79"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="524.89"
					y1="948.75"
					x2="528.64"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="524.89"
					y1="928.73"
					x2="528.64"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="524.89"
					y1="928.73"
					x2="524.89"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="523.64 950 528.64 950 528.64 948.75 523.64 948.75 523.64 950"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="436.04 948.75 431.03 948.75 431.03 950 436.04 950 436.04 948.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="523.64 928.73 528.64 928.73 528.64 927.48 523.64 927.48 523.64 928.73"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="436.04 927.48 431.03 927.48 431.03 928.73 436.04 928.73 436.04 927.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="523.64"
					y1="950"
					x2="528.64"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.64"
					y1="950"
					x2="528.64"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.64"
					y1="948.75"
					x2="523.64"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="523.64"
					y1="948.75"
					x2="523.64"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.04"
					y1="948.75"
					x2="431.03"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.03"
					y1="948.75"
					x2="431.03"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.03"
					y1="950"
					x2="436.04"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.04"
					y1="950"
					x2="436.04"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="523.64"
					y1="928.73"
					x2="528.64"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.64"
					y1="928.73"
					x2="528.64"
					y2="927.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.64"
					y1="927.48"
					x2="523.64"
					y2="927.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="523.64"
					y1="927.48"
					x2="523.64"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.04"
					y1="927.48"
					x2="431.03"
					y2="927.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.03"
					y1="927.48"
					x2="431.03"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.03"
					y1="928.73"
					x2="436.04"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.04"
					y1="928.73"
					x2="436.04"
					y2="927.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="522.38 948.75 524.27 948.75 524.27 928.73 522.38 928.73 522.38 948.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="435.41 948.75 437.29 948.75 437.29 928.73 435.41 928.73 435.41 948.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="497.46 868.56 437.29 928.73 440.39 931.82 500.56 871.65 497.46 868.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="524.27"
					y1="928.73"
					x2="524.89"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.27"
					y1="948.75"
					x2="524.89"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.89"
					y1="928.73"
					x2="524.89"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.41"
					y1="928.73"
					x2="434.79"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.41"
					y1="948.75"
					x2="434.79"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.79"
					y1="928.73"
					x2="434.79"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.38"
					y1="948.75"
					x2="522.38"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.38"
					y1="928.73"
					x2="524.27"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.27"
					y1="928.73"
					x2="524.27"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.27"
					y1="948.75"
					x2="522.38"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.41"
					y1="948.75"
					x2="435.41"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.41"
					y1="928.73"
					x2="437.29"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.29"
					y1="928.73"
					x2="437.29"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.29"
					y1="948.75"
					x2="435.41"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.46"
					y1="868.56"
					x2="500.56"
					y2="871.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.56"
					y1="871.65"
					x2="440.39"
					y2="931.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.39"
					y1="931.83"
					x2="437.29"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.29"
					y1="928.73"
					x2="497.46"
					y2="868.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.89"
					y1="928.73"
					x2="524.89"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="524.89"
					y1="928.73"
					x2="524.89"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="524.89"
					y1="928.73"
					x2="528.64"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="524.89"
					y1="928.73"
					x2="528.64"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="524.89"
					y1="948.75"
					x2="528.64"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="524.89"
					y1="948.75"
					x2="528.64"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="434.79"
					y1="928.73"
					x2="434.79"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="434.79"
					y1="928.73"
					x2="434.79"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="434.79"
					y1="928.73"
					x2="431.03"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="434.79"
					y1="928.73"
					x2="431.03"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="434.79"
					y1="948.75"
					x2="431.03"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="434.79"
					y1="948.75"
					x2="431.03"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="417.1"
					y1="892.1"
					x2="417.1"
					y2="895.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="429.62"
					y1="892.1"
					x2="429.62"
					y2="895.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="429.62"
					y1="892.1"
					x2="417.1"
					y2="892.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="417.1"
					y1="822.03"
					x2="417.1"
					y2="818.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="429.62"
					y1="822.03"
					x2="429.62"
					y2="818.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="429.62"
					y1="822.03"
					x2="417.1"
					y2="822.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="417.1"
					y1="816.66"
					x2="417.1"
					y2="822.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="417.1"
					y1="892.1"
					x2="417.1"
					y2="897.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="415.85 823.28 417.1 823.28 417.1 818.27 415.85 818.27 415.85 823.28"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="417.1 890.85 415.85 890.85 415.85 895.86 417.1 895.86 417.1 890.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="429.62 823.28 430.87 823.28 430.87 818.27 429.62 818.27 429.62 823.28"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="430.87 890.85 429.62 890.85 429.62 895.86 430.87 895.86 430.87 890.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="415.85"
					y1="823.28"
					x2="415.85"
					y2="818.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.85"
					y1="818.27"
					x2="417.1"
					y2="818.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.1"
					y1="818.27"
					x2="417.1"
					y2="823.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.1"
					y1="823.28"
					x2="415.85"
					y2="823.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.1"
					y1="890.85"
					x2="417.1"
					y2="895.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.1"
					y1="895.86"
					x2="415.85"
					y2="895.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.85"
					y1="895.86"
					x2="415.85"
					y2="890.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.85"
					y1="890.85"
					x2="417.1"
					y2="890.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.62"
					y1="823.28"
					x2="429.62"
					y2="818.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.62"
					y1="818.27"
					x2="430.87"
					y2="818.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.87"
					y1="818.27"
					x2="430.87"
					y2="823.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.87"
					y1="823.28"
					x2="429.62"
					y2="823.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.87"
					y1="890.85"
					x2="430.87"
					y2="895.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.87"
					y1="895.86"
					x2="429.62"
					y2="895.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.62"
					y1="895.86"
					x2="429.62"
					y2="890.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.62"
					y1="890.85"
					x2="430.87"
					y2="890.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="417.1 824.53 429.62 824.53 429.62 822.65 417.1 822.65 417.1 824.53"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="417.1 891.48 429.62 891.48 429.62 889.6 417.1 889.6 417.1 891.48"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="475.63 843.59 472.53 840.49 426.52 886.5 429.62 889.6 475.63 843.59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="429.62"
					y1="822.65"
					x2="429.62"
					y2="822.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.1"
					y1="822.65"
					x2="417.1"
					y2="822.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.62"
					y1="822.03"
					x2="417.1"
					y2="822.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.62"
					y1="891.48"
					x2="429.62"
					y2="892.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.1"
					y1="891.48"
					x2="417.1"
					y2="892.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.62"
					y1="892.1"
					x2="417.1"
					y2="892.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.1"
					y1="824.53"
					x2="429.62"
					y2="824.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.62"
					y1="824.53"
					x2="429.62"
					y2="822.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.62"
					y1="822.65"
					x2="417.1"
					y2="822.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.1"
					y1="822.65"
					x2="417.1"
					y2="824.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.1"
					y1="891.48"
					x2="429.62"
					y2="891.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.62"
					y1="891.48"
					x2="429.62"
					y2="889.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.62"
					y1="889.6"
					x2="417.1"
					y2="889.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.1"
					y1="889.6"
					x2="417.1"
					y2="891.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="475.63"
					y1="843.59"
					x2="472.53"
					y2="840.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.53"
					y1="840.49"
					x2="426.52"
					y2="886.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.52"
					y1="886.5"
					x2="429.62"
					y2="889.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.62"
					y1="889.6"
					x2="475.63"
					y2="843.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.62"
					y1="822.03"
					x2="417.1"
					y2="822.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="429.62"
					y1="822.03"
					x2="417.1"
					y2="822.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="429.62"
					y1="822.03"
					x2="429.62"
					y2="818.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="429.62"
					y1="822.03"
					x2="429.62"
					y2="818.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="417.1"
					y1="822.03"
					x2="417.1"
					y2="818.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="417.1"
					y1="822.03"
					x2="417.1"
					y2="818.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="429.62"
					y1="892.1"
					x2="417.1"
					y2="892.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="429.62"
					y1="892.1"
					x2="417.1"
					y2="892.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="429.62"
					y1="892.1"
					x2="429.62"
					y2="895.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="429.62"
					y1="892.1"
					x2="429.62"
					y2="895.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="417.1"
					y1="892.1"
					x2="417.1"
					y2="895.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="417.1"
					y1="892.1"
					x2="417.1"
					y2="895.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="338.66"
					y1="816.66"
					x2="417.1"
					y2="816.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="417.1"
					y1="897.56"
					x2="338.66"
					y2="897.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="657.57"
					y1="904.26"
					x2="657.57"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="448.59"
					y1="634.61"
					x2="452.34"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="448.59"
					y1="622.09"
					x2="452.34"
					y2="622.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="448.59"
					y1="622.09"
					x2="448.59"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="358.49"
					y1="634.61"
					x2="354.74"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="358.49"
					y1="622.09"
					x2="354.74"
					y2="622.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="358.49"
					y1="622.09"
					x2="358.49"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="459.68"
					y1="622.09"
					x2="448.59"
					y2="622.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="359.74 635.86 359.74 634.61 354.74 634.61 354.74 635.86 359.74 635.86"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="447.34 634.61 447.34 635.86 452.34 635.86 452.34 634.61 447.34 634.61"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="359.74 622.09 359.74 620.84 354.74 620.84 354.74 622.09 359.74 622.09"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="447.34 620.84 447.34 622.09 452.34 622.09 452.34 620.84 447.34 620.84"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="359.74"
					y1="635.86"
					x2="354.74"
					y2="635.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.74"
					y1="635.86"
					x2="354.74"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.74"
					y1="634.61"
					x2="359.74"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.74"
					y1="634.61"
					x2="359.74"
					y2="635.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.34"
					y1="634.61"
					x2="452.34"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.34"
					y1="634.61"
					x2="452.34"
					y2="635.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.34"
					y1="635.86"
					x2="447.34"
					y2="635.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.34"
					y1="635.86"
					x2="447.34"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.74"
					y1="622.09"
					x2="354.74"
					y2="622.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.74"
					y1="622.09"
					x2="354.74"
					y2="620.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.74"
					y1="620.84"
					x2="359.74"
					y2="620.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.74"
					y1="620.84"
					x2="359.74"
					y2="622.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.34"
					y1="620.84"
					x2="452.34"
					y2="620.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.34"
					y1="620.84"
					x2="452.34"
					y2="622.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.34"
					y1="622.09"
					x2="447.34"
					y2="622.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.34"
					y1="622.09"
					x2="447.34"
					y2="620.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="360.99 634.61 360.99 622.09 359.11 622.09 359.11 634.61 360.99 634.61"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="447.96 634.61 447.96 622.09 446.09 622.09 446.09 634.61 447.96 634.61"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="385.92 561.92 382.82 565.02 442.99 625.19 446.09 622.09 385.92 561.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="359.11"
					y1="622.09"
					x2="358.49"
					y2="622.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.11"
					y1="634.61"
					x2="358.49"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.49"
					y1="622.09"
					x2="358.49"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.96"
					y1="622.09"
					x2="448.59"
					y2="622.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.96"
					y1="634.61"
					x2="448.59"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.59"
					y1="622.09"
					x2="448.59"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.99"
					y1="634.61"
					x2="360.99"
					y2="622.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.99"
					y1="622.09"
					x2="359.11"
					y2="622.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.11"
					y1="622.09"
					x2="359.11"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.11"
					y1="634.61"
					x2="360.99"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.96"
					y1="634.61"
					x2="447.96"
					y2="622.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.96"
					y1="622.09"
					x2="446.09"
					y2="622.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.09"
					y1="622.09"
					x2="446.09"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.09"
					y1="634.61"
					x2="447.96"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.92"
					y1="561.92"
					x2="382.82"
					y2="565.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="382.82"
					y1="565.02"
					x2="442.99"
					y2="625.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="442.99"
					y1="625.19"
					x2="446.09"
					y2="622.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.09"
					y1="622.09"
					x2="385.92"
					y2="561.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.49"
					y1="622.09"
					x2="358.49"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="358.49"
					y1="622.09"
					x2="358.49"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="358.49"
					y1="622.09"
					x2="354.74"
					y2="622.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="358.49"
					y1="622.09"
					x2="354.74"
					y2="622.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="358.49"
					y1="634.61"
					x2="354.74"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="358.49"
					y1="634.61"
					x2="354.74"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="448.59"
					y1="622.09"
					x2="448.59"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="448.59"
					y1="622.09"
					x2="448.59"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="448.59"
					y1="622.09"
					x2="452.34"
					y2="622.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="448.59"
					y1="622.09"
					x2="452.34"
					y2="622.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="448.59"
					y1="634.61"
					x2="452.34"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="448.59"
					y1="634.61"
					x2="452.34"
					y2="634.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="472.19"
					y1="409.86"
					x2="472.19"
					y2="413.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="459.68"
					y1="409.86"
					x2="459.68"
					y2="413.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="459.68"
					y1="409.86"
					x2="472.19"
					y2="409.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="472.19"
					y1="319.76"
					x2="472.19"
					y2="316"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="459.68"
					y1="319.76"
					x2="459.68"
					y2="316"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="459.68"
					y1="319.76"
					x2="472.19"
					y2="319.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="473.44 321.01 473.44 316 472.19 316 472.19 321.01 473.44 321.01"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="472.19 408.61 472.19 413.61 473.44 413.61 473.44 408.61 472.19 408.61"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="459.68 321.01 459.68 316 458.43 316 458.43 321.01 459.68 321.01"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="458.43 408.61 458.43 413.61 459.68 413.61 459.68 408.61 458.43 408.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="473.44"
					y1="321.01"
					x2="473.44"
					y2="316"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.44"
					y1="316"
					x2="472.19"
					y2="316"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.19"
					y1="316"
					x2="472.19"
					y2="321.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.19"
					y1="321.01"
					x2="473.44"
					y2="321.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.19"
					y1="408.61"
					x2="472.19"
					y2="413.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.19"
					y1="413.61"
					x2="473.44"
					y2="413.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.44"
					y1="413.61"
					x2="473.44"
					y2="408.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.44"
					y1="408.61"
					x2="472.19"
					y2="408.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.68"
					y1="321.01"
					x2="459.68"
					y2="316"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.68"
					y1="316"
					x2="458.43"
					y2="316"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="316"
					x2="458.43"
					y2="321.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="321.01"
					x2="459.68"
					y2="321.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="408.61"
					x2="458.43"
					y2="413.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="413.61"
					x2="459.68"
					y2="413.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.68"
					y1="413.61"
					x2="459.68"
					y2="408.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.68"
					y1="408.61"
					x2="458.43"
					y2="408.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="472.19 322.26 472.19 320.38 459.68 320.38 459.68 322.26 472.19 322.26"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="472.19 409.23 472.19 407.36 459.68 407.36 459.68 409.23 472.19 409.23"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="399.51 347.18 459.68 407.36 462.77 404.26 402.6 344.09 399.51 347.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="459.68"
					y1="320.38"
					x2="459.68"
					y2="319.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.19"
					y1="320.38"
					x2="472.19"
					y2="319.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.68"
					y1="319.76"
					x2="472.19"
					y2="319.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.68"
					y1="409.23"
					x2="459.68"
					y2="409.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.19"
					y1="409.23"
					x2="472.19"
					y2="409.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.68"
					y1="409.86"
					x2="472.19"
					y2="409.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.19"
					y1="322.26"
					x2="459.68"
					y2="322.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.68"
					y1="322.26"
					x2="459.68"
					y2="320.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.68"
					y1="320.38"
					x2="472.19"
					y2="320.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.19"
					y1="320.38"
					x2="472.19"
					y2="322.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.19"
					y1="409.23"
					x2="459.68"
					y2="409.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.68"
					y1="409.23"
					x2="459.68"
					y2="407.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.68"
					y1="407.36"
					x2="472.19"
					y2="407.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.19"
					y1="407.36"
					x2="472.19"
					y2="409.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.51"
					y1="347.18"
					x2="402.6"
					y2="344.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.6"
					y1="344.09"
					x2="462.77"
					y2="404.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.77"
					y1="404.26"
					x2="459.68"
					y2="407.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.68"
					y1="407.36"
					x2="399.51"
					y2="347.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.68"
					y1="319.76"
					x2="472.19"
					y2="319.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="459.68"
					y1="319.76"
					x2="472.19"
					y2="319.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="459.68"
					y1="319.76"
					x2="459.68"
					y2="316"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="459.68"
					y1="319.76"
					x2="459.68"
					y2="316"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="472.19"
					y1="319.76"
					x2="472.19"
					y2="316"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="472.19"
					y1="319.76"
					x2="472.19"
					y2="316"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="459.68"
					y1="409.86"
					x2="472.19"
					y2="409.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="459.68"
					y1="409.86"
					x2="472.19"
					y2="409.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="459.68"
					y1="409.86"
					x2="459.68"
					y2="413.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="459.68"
					y1="409.86"
					x2="459.68"
					y2="413.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="472.19"
					y1="409.86"
					x2="472.19"
					y2="413.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="472.19"
					y1="409.86"
					x2="472.19"
					y2="413.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="301.42"
					y1="452.55"
					x2="459.68"
					y2="452.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="301.42"
					y1="473"
					x2="301.42"
					y2="452.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="301.42"
					y1="473"
					x2="288.91"
					y2="473"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="225.04"
					y1="473"
					x2="288.91"
					y2="473"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="208.31"
					y1="361.28"
					x2="205.18"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="208.31"
					y1="358.77"
					x2="208.31"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="208.31"
					y1="348.76"
					x2="205.18"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="208.31"
					y1="348.76"
					x2="208.31"
					y2="358.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="321.83"
					y1="361.28"
					x2="324.96"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="321.83"
					y1="358.77"
					x2="321.83"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="321.83"
					y1="348.76"
					x2="324.96"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="321.83"
					y1="348.76"
					x2="321.83"
					y2="358.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="326.8"
					y1="348.76"
					x2="321.83"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="208.31"
					y1="348.76"
					x2="203.86"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="203.86"
					y1="361.28"
					x2="208.31"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="321.83"
					y1="361.28"
					x2="326.8"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="319.95 358.77 319.95 361.28 321.2 361.28 321.2 358.77 319.95 358.77"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="319.95 362.53 324.96 362.53 324.96 361.28 319.95 361.28 319.95 362.53"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="208.94 358.77 208.94 361.28 210.19 361.28 210.19 358.77 208.94 358.77"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="210.19 361.28 205.18 361.28 205.18 362.53 210.19 362.53 210.19 361.28"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="319.95 348.76 324.96 348.76 324.96 345.63 319.95 345.63 319.95 348.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="210.19 345.63 205.18 345.63 205.18 348.76 210.19 348.76 210.19 345.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="319.95"
					y1="358.77"
					x2="319.95"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.95"
					y1="361.28"
					x2="321.2"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="321.2"
					y1="361.28"
					x2="321.2"
					y2="358.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="321.2"
					y1="358.77"
					x2="319.95"
					y2="358.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.95"
					y1="362.53"
					x2="324.96"
					y2="362.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.96"
					y1="362.53"
					x2="324.96"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.96"
					y1="361.28"
					x2="319.95"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.95"
					y1="361.28"
					x2="319.95"
					y2="362.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.94"
					y1="358.77"
					x2="208.94"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.94"
					y1="361.28"
					x2="210.19"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.19"
					y1="361.28"
					x2="210.19"
					y2="358.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.19"
					y1="358.77"
					x2="208.94"
					y2="358.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.19"
					y1="361.28"
					x2="205.18"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.18"
					y1="361.28"
					x2="205.18"
					y2="362.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.18"
					y1="362.53"
					x2="210.19"
					y2="362.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.19"
					y1="362.53"
					x2="210.19"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.95"
					y1="348.76"
					x2="324.96"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.96"
					y1="348.76"
					x2="324.96"
					y2="345.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.96"
					y1="345.63"
					x2="319.95"
					y2="345.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.95"
					y1="345.63"
					x2="319.95"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.19"
					y1="345.63"
					x2="205.18"
					y2="345.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.18"
					y1="345.63"
					x2="205.18"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.18"
					y1="348.76"
					x2="210.19"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.19"
					y1="348.76"
					x2="210.19"
					y2="345.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="316.2 358.77 321.2 358.77 321.2 348.76 316.2 348.76 316.2 358.77"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="208.94 358.77 213.94 358.77 213.94 348.76 208.94 348.76 208.94 358.77"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="267.57 348.76 213.94 348.76 213.94 353.14 267.57 353.14 267.57 348.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="286.17 353.14 232.54 353.14 232.54 357.52 286.17 357.52 286.17 353.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="321.2"
					y1="348.76"
					x2="321.83"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="321.2"
					y1="358.77"
					x2="321.83"
					y2="358.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="321.83"
					y1="348.76"
					x2="321.83"
					y2="358.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.94"
					y1="348.76"
					x2="208.31"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.94"
					y1="358.77"
					x2="208.31"
					y2="358.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.31"
					y1="348.76"
					x2="208.31"
					y2="358.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.2"
					y1="358.77"
					x2="316.2"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.2"
					y1="348.76"
					x2="321.2"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="321.2"
					y1="348.76"
					x2="321.2"
					y2="358.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="321.2"
					y1="358.77"
					x2="316.2"
					y2="358.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.94"
					y1="358.77"
					x2="208.94"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.94"
					y1="348.76"
					x2="213.94"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.94"
					y1="348.76"
					x2="213.94"
					y2="358.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.94"
					y1="358.77"
					x2="208.94"
					y2="358.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.57"
					y1="348.76"
					x2="267.57"
					y2="353.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.57"
					y1="353.14"
					x2="213.94"
					y2="353.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.94"
					y1="353.14"
					x2="213.94"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.94"
					y1="348.76"
					x2="267.57"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.17"
					y1="353.14"
					x2="286.17"
					y2="357.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.17"
					y1="357.52"
					x2="232.54"
					y2="357.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="232.54"
					y1="357.52"
					x2="232.54"
					y2="353.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="232.54"
					y1="353.14"
					x2="286.17"
					y2="353.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="321.83"
					y1="348.76"
					x2="321.83"
					y2="358.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="321.83"
					y1="348.76"
					x2="321.83"
					y2="358.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="321.83"
					y1="358.77"
					x2="321.83"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="321.83"
					y1="348.76"
					x2="324.96"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="321.83"
					y1="358.77"
					x2="321.83"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="321.83"
					y1="361.28"
					x2="324.96"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="321.83"
					y1="361.28"
					x2="324.96"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="208.31"
					y1="348.76"
					x2="208.31"
					y2="358.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="208.31"
					y1="348.76"
					x2="208.31"
					y2="358.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="208.31"
					y1="358.77"
					x2="208.31"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="208.31"
					y1="348.76"
					x2="205.18"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="208.31"
					y1="358.77"
					x2="208.31"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="208.31"
					y1="361.28"
					x2="205.18"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="208.31"
					y1="361.28"
					x2="205.18"
					y2="361.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="247.54"
					y1="50"
					x2="247.54"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="414.4"
					y1="50"
					x2="414.4"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="547.41"
					y1="70.02"
					x2="547.41"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="225.04"
					y1="622.09"
					x2="225.04"
					y2="473"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="404.74 518.27 409.2 520.27 414.05 520.96 418.89 520.27 423.35 518.27 426.3 515.74 428.53 512.57 431.37 505.12 432.35 495.8 430.26 486.66 430.95 478.45 434.37 470.95 435.72 468.84 437.3 464.49 437.06 459.86 436.35 458.04 436.35 453.18 434.32 453.18 434.32 455.39 430.93 453.34 427.05 452.55 401.05 452.55 396.02 453.9 392.25 457.48 390.63 462.42 390.63 463.02 391.15 466.15 393.79 471.07 397.18 478.48 397.86 486.6 395.75 495.76 396.73 505.12 399.56 512.57 401.8 515.74 404.74 518.27"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="423.31"
					y1="475.66"
					x2="404.78"
					y2="475.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.05"
					y1="452.55"
					x2="414.05"
					y2="452.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.05"
					y1="453.48"
					x2="414.05"
					y2="453.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.05"
					y1="452.55"
					x2="414.05"
					y2="452.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.05"
					y1="453.48"
					x2="414.05"
					y2="453.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="405.26"
					y1="475.66"
					x2="405.26"
					y2="472.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="405.26"
					y1="472.2"
					x2="408.13"
					y2="472.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="408.13"
					y1="472.2"
					x2="408.13"
					y2="475.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.83"
					y1="475.66"
					x2="422.83"
					y2="472.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.83"
					y1="472.2"
					x2="419.97"
					y2="472.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.97"
					y1="472.2"
					x2="419.97"
					y2="475.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.32"
					y1="461.78"
					x2="434.32"
					y2="453.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.35"
					y1="461.78"
					x2="436.35"
					y2="453.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.35"
					y1="453.18"
					x2="434.32"
					y2="453.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.35"
					y1="461.78"
					x2="434.32"
					y2="461.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414.05"
					y1="520.96"
					x2="410.94"
					y2="520.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.94"
					y1="520.6"
					x2="407.94"
					y2="519.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.94"
					y1="519.8"
					x2="404.74"
					y2="518.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="404.74"
					y1="518.27"
					x2="401.79"
					y2="515.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.79"
					y1="515.75"
					x2="399.56"
					y2="512.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.56"
					y1="512.57"
					x2="397.92"
					y2="508.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.92"
					y1="508.96"
					x2="396.73"
					y2="505.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.73"
					y1="505.12"
					x2="395.65"
					y2="498.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.65"
					y1="498.92"
					x2="395.59"
					y2="495.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.59"
					y1="495.8"
					x2="395.94"
					y2="492.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.94"
					y1="492.69"
					x2="397.35"
					y2="487.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.35"
					y1="487.85"
					x2="399.54"
					y2="483.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.54"
					y1="483.17"
					x2="402.14"
					y2="479"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.14"
					y1="479"
					x2="404.78"
					y2="475.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.86"
					y1="486.6"
					x2="397.83"
					y2="482.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.83"
					y1="482.26"
					x2="397.12"
					y2="478.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.12"
					y1="478.04"
					x2="396.38"
					y2="475.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.38"
					y1="475.76"
					x2="395.32"
					y2="473.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.32"
					y1="473.51"
					x2="393.23"
					y2="470.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.23"
					y1="470.23"
					x2="391.39"
					y2="466.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.39"
					y1="466.84"
					x2="390.65"
					y2="463.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.65"
					y1="463.53"
					x2="390.93"
					y2="460.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.93"
					y1="460.23"
					x2="392.22"
					y2="457.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="392.22"
					y1="457.22"
					x2="393.23"
					y2="455.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.23"
					y1="455.93"
					x2="394.49"
					y2="454.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.49"
					y1="454.81"
					x2="396.71"
					y2="453.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.71"
					y1="453.58"
					x2="398.83"
					y2="452.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.83"
					y1="452.9"
					x2="401.05"
					y2="452.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.05"
					y1="453.48"
					x2="400.05"
					y2="453.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.05"
					y1="453.58"
					x2="398.01"
					y2="454.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.01"
					y1="454.21"
					x2="396.21"
					y2="455.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.21"
					y1="455.74"
					x2="395.07"
					y2="457.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.07"
					y1="457.85"
					x2="394.53"
					y2="460.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.53"
					y1="460.65"
					x2="394.41"
					y2="463.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.41"
					y1="463.52"
					x2="394.43"
					y2="464.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.43"
					y1="464.95"
					x2="395.03"
					y2="466.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.03"
					y1="466.08"
					x2="395.74"
					y2="466.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.74"
					y1="466.41"
					x2="403.6"
					y2="468.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.6"
					y1="468.65"
					x2="407.51"
					y2="469.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.51"
					y1="469.31"
					x2="411.46"
					y2="469.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="411.46"
					y1="469.6"
					x2="414.05"
					y2="469.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.26"
					y1="486.66"
					x2="430.29"
					y2="482.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.29"
					y1="482.31"
					x2="431"
					y2="478.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431"
					y1="478.07"
					x2="431.72"
					y2="475.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.72"
					y1="475.78"
					x2="432.77"
					y2="473.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.77"
					y1="473.51"
					x2="434.85"
					y2="470.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.85"
					y1="470.23"
					x2="436.7"
					y2="466.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.7"
					y1="466.84"
					x2="437.31"
					y2="464.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.31"
					y1="464.63"
					x2="437.46"
					y2="462.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.46"
					y1="462.35"
					x2="437.13"
					y2="460.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.13"
					y1="460.13"
					x2="436.35"
					y2="458.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.05"
					y1="453.48"
					x2="428.04"
					y2="453.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.04"
					y1="453.58"
					x2="430.08"
					y2="454.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.08"
					y1="454.21"
					x2="431.89"
					y2="455.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.89"
					y1="455.74"
					x2="433.02"
					y2="457.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.02"
					y1="457.85"
					x2="433.56"
					y2="460.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.56"
					y1="460.65"
					x2="433.68"
					y2="463.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.68"
					y1="463.52"
					x2="433.67"
					y2="464.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.67"
					y1="464.95"
					x2="433.06"
					y2="466.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.06"
					y1="466.08"
					x2="432.36"
					y2="466.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.36"
					y1="466.41"
					x2="424.49"
					y2="468.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.49"
					y1="468.65"
					x2="420.58"
					y2="469.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="420.58"
					y1="469.31"
					x2="416.63"
					y2="469.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="416.63"
					y1="469.6"
					x2="414.05"
					y2="469.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414.05"
					y1="520.96"
					x2="417.15"
					y2="520.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.15"
					y1="520.6"
					x2="420.16"
					y2="519.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="420.16"
					y1="519.8"
					x2="423.35"
					y2="518.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.35"
					y1="518.27"
					x2="426.3"
					y2="515.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.3"
					y1="515.75"
					x2="428.53"
					y2="512.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.53"
					y1="512.57"
					x2="430.17"
					y2="508.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.17"
					y1="508.96"
					x2="431.37"
					y2="505.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.37"
					y1="505.12"
					x2="432.45"
					y2="498.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.45"
					y1="498.92"
					x2="432.5"
					y2="495.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.5"
					y1="495.8"
					x2="432.15"
					y2="492.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.15"
					y1="492.69"
					x2="430.74"
					y2="487.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.74"
					y1="487.85"
					x2="428.56"
					y2="483.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.56"
					y1="483.17"
					x2="425.95"
					y2="479"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.95"
					y1="479"
					x2="423.31"
					y2="475.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="392.26"
					y1="468.64"
					x2="392.76"
					y2="469.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="392.76"
					y1="469.35"
					x2="394.19"
					y2="470.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.19"
					y1="470.41"
					x2="395.43"
					y2="470.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.43"
					y1="470.65"
					x2="403.42"
					y2="471.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.42"
					y1="471.34"
					x2="411.43"
					y2="471.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="411.43"
					y1="471.65"
					x2="414.05"
					y2="471.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.83"
					y1="468.64"
					x2="435.33"
					y2="469.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.33"
					y1="469.35"
					x2="433.9"
					y2="470.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.9"
					y1="470.41"
					x2="432.66"
					y2="470.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.66"
					y1="470.65"
					x2="424.67"
					y2="471.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.67"
					y1="471.34"
					x2="416.67"
					y2="471.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="416.67"
					y1="471.65"
					x2="414.05"
					y2="471.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.32"
					y1="455.39"
					x2="433.6"
					y2="454.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.6"
					y1="454.81"
					x2="431.39"
					y2="453.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.39"
					y1="453.58"
					x2="429.26"
					y2="452.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.26"
					y1="452.9"
					x2="427.05"
					y2="452.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="384.01 452.55 384.01 453.55 389.02 453.55 389.02 452.55 384.01 452.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="389.02"
					y1="452.55"
					x2="384.01"
					y2="452.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.02"
					y1="453.55"
					x2="389.02"
					y2="452.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.01"
					y1="453.55"
					x2="389.02"
					y2="453.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.01"
					y1="452.55"
					x2="384.01"
					y2="453.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="444.08 452.55 439.07 452.55 439.07 453.55 444.08 453.55 444.08 452.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="444.08"
					y1="453.55"
					x2="444.08"
					y2="452.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.07"
					y1="453.55"
					x2="444.08"
					y2="453.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.07"
					y1="452.55"
					x2="439.07"
					y2="453.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.08"
					y1="452.55"
					x2="439.07"
					y2="452.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="386.01 453.55 386.01 461.69 387.02 461.69 387.02 453.55 386.01 453.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="387.02"
					y1="453.55"
					x2="386.01"
					y2="453.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="387.02"
					y1="461.69"
					x2="387.02"
					y2="453.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.01"
					y1="461.69"
					x2="387.02"
					y2="461.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.01"
					y1="453.55"
					x2="386.01"
					y2="461.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="442.08 453.55 441.07 453.55 441.07 461.69 442.08 461.69 442.08 453.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="442.08"
					y1="461.69"
					x2="442.08"
					y2="453.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.07"
					y1="461.69"
					x2="442.08"
					y2="461.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.07"
					y1="453.55"
					x2="441.07"
					y2="461.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="442.08"
					y1="453.55"
					x2="441.07"
					y2="453.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="387.02 459.19 387.02 461.19 441.07 461.19 441.07 459.19 387.02 459.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="441.07"
					y1="459.19"
					x2="387.02"
					y2="459.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.07"
					y1="461.19"
					x2="441.07"
					y2="459.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="387.02"
					y1="461.19"
					x2="441.07"
					y2="461.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="387.02"
					y1="459.19"
					x2="387.02"
					y2="461.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="301.42 473 225.04 473 225.04 622.09 301.42 622.09 301.42 473"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="301.42"
					y1="622.09"
					x2="301.42"
					y2="473"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.04"
					y1="622.09"
					x2="301.42"
					y2="622.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.04"
					y1="473"
					x2="225.04"
					y2="622.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="301.42"
					y1="473"
					x2="225.04"
					y2="473"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="292.37 482.34 235.09 482.34 235.09 612.11 292.37 612.11 292.37 482.34"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="292.37"
					y1="612.11"
					x2="292.37"
					y2="482.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.09"
					y1="612.11"
					x2="292.37"
					y2="612.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.09"
					y1="482.34"
					x2="235.09"
					y2="612.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="292.37"
					y1="482.34"
					x2="235.09"
					y2="482.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="263.23 495.09 263.74 495.05 264.24 494.92 264.71 494.71 265.13 494.43 265.5 494.08 265.8 493.67 266.01 493.22 266.15 492.74 266.19 492.25 266.15 491.75 266.01 491.27 265.8 490.82 265.5 490.42 265.13 490.06 264.71 489.78 264.24 489.57 263.74 489.44 263.23 489.4 262.72 489.44 262.22 489.57 261.75 489.78 261.33 490.06 260.96 490.42 260.67 490.82 260.45 491.27 260.31 491.75 260.27 492.25 260.31 492.74 260.45 493.22 260.67 493.67 260.96 494.08 261.33 494.43 261.75 494.71 262.22 494.92 262.72 495.05 263.23 495.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="262.72"
					y1="495.05"
					x2="263.23"
					y2="495.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.22"
					y1="494.92"
					x2="262.72"
					y2="495.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.75"
					y1="494.71"
					x2="262.22"
					y2="494.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.33"
					y1="494.43"
					x2="261.75"
					y2="494.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.96"
					y1="494.08"
					x2="261.33"
					y2="494.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.67"
					y1="493.67"
					x2="260.96"
					y2="494.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.45"
					y1="493.22"
					x2="260.67"
					y2="493.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.31"
					y1="492.74"
					x2="260.45"
					y2="493.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.27"
					y1="492.25"
					x2="260.31"
					y2="492.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.31"
					y1="491.75"
					x2="260.27"
					y2="492.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.45"
					y1="491.27"
					x2="260.31"
					y2="491.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.67"
					y1="490.82"
					x2="260.45"
					y2="491.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.96"
					y1="490.42"
					x2="260.67"
					y2="490.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.33"
					y1="490.06"
					x2="260.96"
					y2="490.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.75"
					y1="489.78"
					x2="261.33"
					y2="490.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.22"
					y1="489.57"
					x2="261.75"
					y2="489.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.72"
					y1="489.44"
					x2="262.22"
					y2="489.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.23"
					y1="489.4"
					x2="262.72"
					y2="489.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.74"
					y1="489.44"
					x2="263.23"
					y2="489.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.24"
					y1="489.57"
					x2="263.74"
					y2="489.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.71"
					y1="489.78"
					x2="264.24"
					y2="489.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.13"
					y1="490.06"
					x2="264.71"
					y2="489.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.5"
					y1="490.42"
					x2="265.13"
					y2="490.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.8"
					y1="490.82"
					x2="265.5"
					y2="490.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.01"
					y1="491.27"
					x2="265.8"
					y2="490.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.15"
					y1="491.75"
					x2="266.01"
					y2="491.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.19"
					y1="492.25"
					x2="266.15"
					y2="491.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.15"
					y1="492.74"
					x2="266.19"
					y2="492.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.01"
					y1="493.22"
					x2="266.15"
					y2="492.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.8"
					y1="493.67"
					x2="266.01"
					y2="493.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.5"
					y1="494.08"
					x2="265.8"
					y2="493.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.13"
					y1="494.43"
					x2="265.5"
					y2="494.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.71"
					y1="494.71"
					x2="265.13"
					y2="494.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.24"
					y1="494.92"
					x2="264.71"
					y2="494.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.74"
					y1="495.05"
					x2="264.24"
					y2="494.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.23"
					y1="495.09"
					x2="263.74"
					y2="495.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="260.67 479.01 260.71 478.58 260.83 478.17 261.02 477.78 261.27 477.43 261.59 477.13 261.95 476.88 262.36 476.7 262.79 476.59 263.23 476.55 263.67 476.59 264.1 476.7 264.51 476.88 264.87 477.13 265.19 477.43 265.44 477.78 265.63 478.17 265.75 478.58 265.79 479.01 265.38 483.13 265.32 483.46 265.21 483.77 265.04 484.06 264.36 489.27 264.32 489.45 264.25 489.62 264.15 489.78 264.02 489.92 263.87 490.04 263.7 490.13 263.52 490.19 263.33 490.22 263.13 490.22 262.94 490.19 262.76 490.13 262.59 490.04 262.44 489.92 262.31 489.78 262.21 489.62 262.14 489.45 262.1 489.26 261.42 484.06 261.25 483.77 261.14 483.46 261.08 483.13 260.67 479.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="260.67"
					y1="479.01"
					x2="261.08"
					y2="483.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.42"
					y1="484.06"
					x2="262.1"
					y2="489.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.36"
					y1="489.26"
					x2="265.04"
					y2="484.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.38"
					y1="483.13"
					x2="265.79"
					y2="479.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.62"
					y1="481.46"
					x2="264.62"
					y2="482.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.84"
					y1="482.92"
					x2="261.84"
					y2="481.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.84"
					y1="481.46"
					x2="264.62"
					y2="481.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m261.42,484.06c-.19-.28-.3-.6-.33-.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m264.36,489.26c-.07.55-.56.96-1.13.96s-1.06-.41-1.13-.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m265.38,483.13c-.03.33-.15.65-.33.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m260.67,479.01c0-1.36,1.14-2.45,2.56-2.45s2.56,1.1,2.56,2.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m264.62,482.92c0,.74-.62,1.34-1.39,1.34s-1.39-.6-1.39-1.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m265.04,484.06c-.4.59-1.08.95-1.81.95s-1.42-.36-1.81-.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="709.15 666.01 766.26 666.01 766.26 609.88 709.15 609.88 709.15 666.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="709.15"
					y1="609.88"
					x2="709.15"
					y2="612.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.15"
					y1="615.72"
					x2="709.15"
					y2="621.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.15"
					y1="625.33"
					x2="709.15"
					y2="631.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.15"
					y1="634.94"
					x2="709.15"
					y2="640.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.15"
					y1="644.55"
					x2="709.15"
					y2="650.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.15"
					y1="654.16"
					x2="709.15"
					y2="660.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.15"
					y1="663.77"
					x2="709.15"
					y2="666.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.26"
					y1="609.88"
					x2="763.53"
					y2="609.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.93"
					y1="609.88"
					x2="753.92"
					y2="609.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.32"
					y1="609.88"
					x2="744.31"
					y2="609.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.7"
					y1="609.88"
					x2="734.7"
					y2="609.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.1"
					y1="609.88"
					x2="725.09"
					y2="609.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.48"
					y1="609.88"
					x2="715.48"
					y2="609.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.87"
					y1="609.88"
					x2="709.15"
					y2="609.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.26"
					y1="666.01"
					x2="766.26"
					y2="663.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.26"
					y1="660.17"
					x2="766.26"
					y2="654.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.26"
					y1="650.56"
					x2="766.26"
					y2="644.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.26"
					y1="640.95"
					x2="766.26"
					y2="634.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.26"
					y1="631.34"
					x2="766.26"
					y2="625.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.26"
					y1="621.73"
					x2="766.26"
					y2="615.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.26"
					y1="612.12"
					x2="766.26"
					y2="609.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.15"
					y1="666.01"
					x2="711.87"
					y2="666.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.48"
					y1="666.01"
					x2="721.48"
					y2="666.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.09"
					y1="666.01"
					x2="731.1"
					y2="666.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.7"
					y1="666.01"
					x2="740.7"
					y2="666.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.31"
					y1="666.01"
					x2="750.32"
					y2="666.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.92"
					y1="666.01"
					x2="759.93"
					y2="666.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.53"
					y1="666.01"
					x2="766.26"
					y2="666.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="706.19 610.09 704.47 610.09 704.47 665.79 706.19 665.79 706.19 657.06 704.78 657.06 704.78 618.83 706.19 618.83 706.19 610.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="706.19"
					y1="618.83"
					x2="706.19"
					y2="610.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="704.78"
					y1="618.83"
					x2="706.19"
					y2="618.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="704.78"
					y1="657.06"
					x2="704.78"
					y2="618.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="706.19"
					y1="657.06"
					x2="704.78"
					y2="657.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="706.19"
					y1="665.79"
					x2="706.19"
					y2="657.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="704.47"
					y1="665.79"
					x2="706.19"
					y2="665.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="704.47"
					y1="610.09"
					x2="704.47"
					y2="665.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="706.19"
					y1="610.09"
					x2="704.47"
					y2="610.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<polyline
					points="706.19 607.91 706.19 667.98 709.15 667.98 709.15 607.91 706.19 607.91"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="709.15"
					y1="607.91"
					x2="706.19"
					y2="607.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="709.15"
					y1="667.98"
					x2="709.15"
					y2="607.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="706.19"
					y1="667.98"
					x2="709.15"
					y2="667.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="706.19"
					y1="607.91"
					x2="706.19"
					y2="667.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="706.19"
					y1="665.79"
					x2="704.47"
					y2="665.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.47"
					y1="665.79"
					x2="704.47"
					y2="610.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.47"
					y1="610.09"
					x2="706.19"
					y2="610.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.19"
					y1="667.98"
					x2="706.19"
					y2="607.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.19"
					y1="618.83"
					x2="704.78"
					y2="618.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.78"
					y1="618.83"
					x2="704.78"
					y2="657.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.78"
					y1="657.06"
					x2="706.19"
					y2="657.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.15"
					y1="667.98"
					x2="706.19"
					y2="667.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.19"
					y1="607.91"
					x2="709.15"
					y2="607.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.15"
					y1="607.91"
					x2="709.15"
					y2="667.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="701.18 744.7 701.18 819.78 766.26 819.78 766.26 744.7 701.18 744.7"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="701.18"
					y1="744.7"
					x2="701.18"
					y2="819.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.26"
					y1="744.7"
					x2="766.26"
					y2="819.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.29"
					y1="744.7"
					x2="764.29"
					y2="819.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.18"
					y1="744.7"
					x2="766.26"
					y2="744.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.18"
					y1="819.78"
					x2="766.26"
					y2="819.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.14"
					y1="749.62"
					x2="704.14"
					y2="814.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.14"
					y1="814.85"
					x2="706.11"
					y2="816.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.11"
					y1="816.82"
					x2="761.33"
					y2="816.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.33"
					y1="816.82"
					x2="763.3"
					y2="814.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.3"
					y1="814.85"
					x2="763.3"
					y2="749.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.3"
					y1="749.62"
					x2="761.33"
					y2="747.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.33"
					y1="747.65"
					x2="706.11"
					y2="747.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.11"
					y1="747.65"
					x2="704.14"
					y2="749.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m727.31,763.47c0-5.44-4.41-9.85-9.85-9.85s-9.85,4.41-9.85,9.85,4.41,9.85,9.85,9.85,9.85-4.41,9.85-9.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m757.38,763.47c0-4.08-3.31-7.39-7.39-7.39s-7.39,3.31-7.39,7.39,3.31,7.39,7.39,7.39,7.39-3.31,7.39-7.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m724.84,801.01c0-4.08-3.31-7.39-7.39-7.39s-7.39,3.31-7.39,7.39,3.31,7.39,7.39,7.39,7.39-3.31,7.39-7.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m759.85,801.01c0-5.44-4.41-9.85-9.85-9.85s-9.85,4.41-9.85,9.85,4.41,9.85,9.85,9.85,9.85-4.41,9.85-9.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.66"
					y1="835.21"
					x2="657.57"
					y2="835.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="657.57"
					y1="835.21"
					x2="657.57"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.66"
					y1="928.73"
					x2="573.66"
					y2="835.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.66"
					y1="841.46"
					x2="657.57"
					y2="841.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="713.39 675.16 713.39 737.51 713.65 738.5 714.37 739.22 715.36 739.48 757.09 739.48 758.08 739.22 758.8 738.5 759.06 737.51 759.06 675.16 758.8 674.18 758.08 673.46 757.09 673.19 715.36 673.19 714.37 673.46 713.65 674.18 713.39 675.16"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m713.39,675.16c0-1.09.88-1.97,1.97-1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.09"
					y1="673.19"
					x2="715.36"
					y2="673.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m757.09,673.19c1.09,0,1.97.88,1.97,1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.06"
					y1="737.51"
					x2="759.06"
					y2="675.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m759.06,737.51c0,1.09-.88,1.97-1.97,1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.36"
					y1="739.48"
					x2="757.09"
					y2="739.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m715.36,739.48c-1.09,0-1.97-.88-1.97-1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.39"
					y1="675.16"
					x2="713.39"
					y2="737.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.31"
					y1="680.09"
					x2="718.31"
					y2="732.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.28"
					y1="734.55"
					x2="747.24"
					y2="734.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.21"
					y1="732.58"
					x2="749.21"
					y2="680.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.24"
					y1="678.12"
					x2="720.28"
					y2="678.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.31"
					y1="680.09"
					x2="718.31"
					y2="680.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m720.28,734.55c-1.09,0-1.97-.88-1.97-1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m749.21,732.58c0,1.09-.88,1.97-1.97,1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m747.24,678.12c1.09,0,1.97.88,1.97,1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m718.31,680.09c0-1.09.88-1.97,1.97-1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m742.31,706.34c0-1.63-1.32-2.96-2.96-2.96s-2.95,1.33-2.95,2.96,1.32,2.95,2.95,2.95,2.96-1.32,2.96-2.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="736.61 705.45 735.98 705.71 735.72 706.34 735.98 706.97 736.61 707.22 756.11 707.22 756.73 706.97 756.99 706.34 756.73 705.71 756.11 705.45 736.61 705.45"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="756.11"
					y1="705.45"
					x2="736.61"
					y2="705.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m756.11,705.45c.49,0,.89.4.89.89s-.4.89-.89.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.61"
					y1="707.22"
					x2="756.11"
					y2="707.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m736.61,707.22h0c-.49,0-.89-.4-.89-.89s.4-.89.89-.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="751.08 704.37 751.08 705.45 756.11 705.45 756.73 705.71 756.99 706.34 756.73 706.97 756.11 707.22 751.08 707.22 751.08 708.31 757.48 708.31 757.48 704.37 751.08 704.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="757.48"
					y1="704.37"
					x2="751.08"
					y2="704.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.48"
					y1="708.31"
					x2="757.48"
					y2="704.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.08"
					y1="708.31"
					x2="757.48"
					y2="708.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.08"
					y1="707.22"
					x2="751.08"
					y2="708.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.11"
					y1="707.22"
					x2="751.08"
					y2="707.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m756.11,705.45c.49,0,.89.4.89.89s-.4.89-.89.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.08"
					y1="705.45"
					x2="756.11"
					y2="705.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.08"
					y1="704.37"
					x2="751.08"
					y2="705.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="747.53 704.4 747.53 705.45 750.98 705.45 750.98 704.4 747.53 704.4"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="750.98"
					y1="704.4"
					x2="747.53"
					y2="704.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.98"
					y1="705.45"
					x2="750.98"
					y2="704.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.53"
					y1="705.45"
					x2="750.98"
					y2="705.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.53"
					y1="704.4"
					x2="747.53"
					y2="705.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="747.53 708.28 750.98 708.28 750.98 707.22 747.53 707.22 747.53 708.28"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="747.53"
					y1="707.22"
					x2="747.53"
					y2="708.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.98"
					y1="707.22"
					x2="747.53"
					y2="707.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.98"
					y1="708.28"
					x2="750.98"
					y2="707.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.53"
					y1="708.28"
					x2="750.98"
					y2="708.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="306.27 502.58 371.35 502.58 371.35 452.55 306.27 452.55 306.27 502.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="306.27"
					y1="502.58"
					x2="371.35"
					y2="502.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="306.27"
					y1="452.55"
					x2="371.35"
					y2="452.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.35"
					y1="502.58"
					x2="371.35"
					y2="452.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="306.27"
					y1="502.58"
					x2="306.27"
					y2="452.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="306.27"
					y1="454.52"
					x2="371.35"
					y2="454.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.78"
					y1="490.7"
					x2="363.84"
					y2="490.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="363.84"
					y1="490.7"
					x2="363.84"
					y2="460.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="363.84"
					y1="460.67"
					x2="313.78"
					y2="460.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.78"
					y1="460.67"
					x2="313.78"
					y2="490.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.81"
					y1="492.67"
					x2="365.81"
					y2="492.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.81"
					y1="492.67"
					x2="365.81"
					y2="458.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.81"
					y1="458.7"
					x2="311.81"
					y2="458.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.81"
					y1="458.7"
					x2="311.81"
					y2="492.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m341.77,467.45c0-1.64-1.32-2.96-2.95-2.96s-2.96,1.32-2.96,2.96,1.32,2.95,2.96,2.95,2.95-1.32,2.95-2.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="336.35 455.25 336.74 459.38 337.06 460.32 337.72 465.54 338.08 466.23 338.81 466.5 339.54 466.23 339.9 465.54 340.56 460.32 340.88 459.38 341.27 455.25 340.8 453.8 339.57 452.91 338.05 452.91 336.82 453.8 336.35 455.25"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m336.35,455.25c0-1.36,1.1-2.46,2.46-2.46s2.46,1.1,2.46,2.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.88"
					y1="459.38"
					x2="341.27"
					y2="455.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m340.88,459.38c-.03.34-.14.65-.32.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.9"
					y1="465.54"
					x2="340.56"
					y2="460.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m339.9,465.54c-.07.55-.54.96-1.09.96s-1.02-.41-1.09-.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.06"
					y1="460.32"
					x2="337.72"
					y2="465.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m337.06,460.32c-.18-.28-.29-.6-.32-.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="336.35"
					y1="455.25"
					x2="336.74"
					y2="459.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.15"
					y1="457.7"
					x2="340.15"
					y2="459.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.47"
					y1="459.17"
					x2="337.47"
					y2="457.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.47"
					y1="457.7"
					x2="340.15"
					y2="457.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m340.15,459.17c0,.74-.6,1.34-1.34,1.34s-1.34-.6-1.34-1.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m340.56,460.32c-.38.59-1.04.95-1.75.95s-1.37-.36-1.75-.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.35"
					y1="835.5"
					x2="409.38"
					y2="835.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.38"
					y1="835.5"
					x2="409.38"
					y2="879.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.35"
					y1="826.34"
					x2="393.35"
					y2="888.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.12"
					y1="888.18"
					x2="352.12"
					y2="826.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.12"
					y1="826.34"
					x2="413.96"
					y2="826.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.96"
					y1="888.18"
					x2="352.12"
					y2="888.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.81"
					y1="826.34"
					x2="412.81"
					y2="888.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.35"
					y1="879.01"
					x2="409.38"
					y2="879.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.96"
					y1="826.34"
					x2="413.96"
					y2="888.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.19"
					y1="604.63"
					x2="766.26"
					y2="604.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.78"
					y1="835.21"
					x2="654.78"
					y2="829.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.78"
					y1="829.68"
					x2="651.98"
					y2="829.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="651.98"
					y1="829.68"
					x2="651.98"
					y2="835.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.66"
					y1="844.19"
					x2="575.52"
					y2="844.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.98"
					y1="844.19"
					x2="584.98"
					y2="844.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="588.59"
					y1="844.19"
					x2="594.6"
					y2="844.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.2"
					y1="844.19"
					x2="604.21"
					y2="844.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="607.81"
					y1="844.19"
					x2="613.82"
					y2="844.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.42"
					y1="844.19"
					x2="623.43"
					y2="844.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="627.03"
					y1="844.19"
					x2="633.04"
					y2="844.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="636.64"
					y1="844.19"
					x2="642.65"
					y2="844.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.25"
					y1="844.19"
					x2="652.26"
					y2="844.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.71"
					y1="844.19"
					x2="657.57"
					y2="844.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.54"
					y1="50"
					x2="414.4"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.4"
					y1="70.02"
					x2="247.54"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.41"
					y1="50"
					x2="743.54"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.54"
					y1="70.02"
					x2="547.41"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.99"
					y1="835.5"
					x2="358.99"
					y2="879.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.99"
					y1="879.01"
					x2="388.76"
					y2="879.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.76"
					y1="879.01"
					x2="388.76"
					y2="835.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.76"
					y1="835.5"
					x2="358.99"
					y2="835.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="604.63"
					x2="736.23"
					y2="607.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="611.48"
					x2="736.23"
					y2="617.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="621.09"
					x2="736.23"
					y2="627.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="630.71"
					x2="736.23"
					y2="636.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="640.31"
					x2="736.23"
					y2="646.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="649.93"
					x2="736.23"
					y2="655.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="659.54"
					x2="736.23"
					y2="665.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="669.15"
					x2="736.23"
					y2="675.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="678.76"
					x2="736.23"
					y2="684.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="688.37"
					x2="736.23"
					y2="694.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="697.98"
					x2="736.23"
					y2="703.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="707.59"
					x2="736.23"
					y2="713.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="717.2"
					x2="736.23"
					y2="723.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="726.81"
					x2="736.23"
					y2="732.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="736.42"
					x2="736.23"
					y2="742.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="746.03"
					x2="736.23"
					y2="752.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="755.65"
					x2="736.23"
					y2="761.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="765.26"
					x2="736.23"
					y2="771.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="774.87"
					x2="736.23"
					y2="780.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="784.48"
					x2="736.23"
					y2="790.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="794.09"
					x2="736.23"
					y2="800.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="803.7"
					x2="736.23"
					y2="809.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="813.31"
					x2="736.23"
					y2="819.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="822.92"
					x2="736.23"
					y2="828.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="832.53"
					x2="736.23"
					y2="838.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="842.14"
					x2="736.23"
					y2="848.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="851.76"
					x2="736.23"
					y2="857.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="861.36"
					x2="736.23"
					y2="867.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.23"
					y1="870.98"
					x2="736.23"
					y2="874.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="547.41 50 547.41 70.02 524.71 70.02 524.71 150.91 472.19 150.91 472.19 319.75 459.68 319.75 459.68 70.02 414.4 70.02 414.4 50 547.41 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.13"
				/>
				<polygon
					points="816.16 50 816.16 948.75 524.89 948.75 524.89 928.73 657.58 928.73 657.58 904.27 766.26 904.27 766.26 604.63 796.14 604.63 796.14 70.02 743.54 70.02 743.54 50 816.16 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.13"
				/>
				<polygon
					points="472.19 409.85 472.19 634.61 448.59 634.61 448.59 622.1 459.68 622.1 459.68 452.55 301.42 452.55 301.42 473 225.04 473 225.04 622.1 358.49 622.1 358.49 634.61 338.65 634.61 338.65 804.14 429.61 804.14 429.61 822.03 417.11 822.03 417.11 816.66 338.65 816.66 338.65 897.57 417.11 897.57 417.11 892.11 429.61 892.11 429.61 928.73 434.79 928.73 434.79 948.75 318.64 948.75 318.64 642.12 183.84 642.12 183.84 50 247.54 50 247.54 70.02 203.86 70.02 203.86 348.76 208.31 348.76 208.31 361.28 203.86 361.28 203.86 422.23 326.8 422.23 326.8 361.28 321.84 361.28 321.84 348.76 339.32 348.76 339.32 422.23 459.68 422.23 459.68 409.85 472.19 409.85"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.13"
				/>
			</g>
			<g id="text">
				<path d="m738.61,643.18v-11.6h4c.9,0,1.59.06,2.07.17.66.15,1.23.43,1.7.83.61.52,1.07,1.18,1.37,1.99.31.8.46,1.72.46,2.75,0,.88-.1,1.66-.31,2.34-.21.68-.47,1.25-.79,1.69-.32.44-.68.79-1.06,1.05-.38.25-.84.45-1.39.58-.54.13-1.16.2-1.86.2h-4.19Zm1.54-1.37h2.48c.77,0,1.36-.07,1.8-.21.44-.14.79-.34,1.04-.6.36-.36.65-.85.85-1.46.21-.62.31-1.36.31-2.24,0-1.21-.2-2.15-.6-2.79-.4-.65-.88-1.09-1.45-1.31-.41-.16-1.07-.24-1.99-.24h-2.44v8.87Zm12.2,1.37l-3.08-11.6h1.58l1.77,7.61c.19.8.35,1.59.49,2.37.3-1.24.47-1.96.52-2.15l2.21-7.84h1.85l1.66,5.87c.42,1.46.72,2.83.9,4.11.15-.73.34-1.58.58-2.53l1.82-7.46h1.54l-3.18,11.6h-1.48l-2.45-8.84c-.21-.74-.33-1.19-.36-1.36-.12.53-.23.99-.34,1.36l-2.46,8.84h-1.57Z" />
				<path d="m611.96,888.92h-1.63l-1.96-3.28c-.18-.3-.35-.56-.52-.77-.17-.22-.34-.39-.52-.53-.17-.14-.36-.23-.57-.29-.2-.07-.43-.1-.68-.1h-1.13v4.97h-1.37v-11.69h3.49c.51,0,.98.07,1.41.2.43.13.81.32,1.13.58.32.26.57.59.75.98.18.39.27.84.27,1.36,0,.41-.06.78-.19,1.13-.12.34-.29.64-.52.91-.22.27-.49.49-.82.68-.32.18-.67.33-1.07.43v.03c.2.09.36.19.51.3.15.11.29.24.42.39.13.15.26.33.38.52.13.19.27.41.43.67l2.19,3.51Zm-7.01-10.45v4.24h1.86c.34,0,.66-.05.95-.15.29-.1.55-.25.76-.44.21-.2.38-.43.5-.71.12-.28.18-.6.18-.95,0-.63-.2-1.11-.61-1.46-.4-.35-.99-.53-1.75-.53h-1.88Zm14.99,6.61h-5.9c.02.93.27,1.65.75,2.15.48.51,1.14.76,1.97.76.94,0,1.8-.31,2.59-.93v1.26c-.73.53-1.7.8-2.91.8s-2.11-.38-2.78-1.13c-.67-.76-1.01-1.83-1.01-3.2,0-1.3.37-2.36,1.1-3.17.74-.82,1.66-1.23,2.75-1.23s1.94.35,2.54,1.06c.6.71.9,1.69.9,2.94v.7Zm-1.37-1.13c0-.77-.19-1.37-.56-1.8-.36-.43-.87-.64-1.52-.64s-1.17.23-1.61.68c-.44.45-.71,1.04-.82,1.77h4.51Zm7.36-6.21c-.26-.15-.56-.22-.89-.22-.94,0-1.4.59-1.4,1.77v1.29h1.96v1.14h-1.96v7.21h-1.33v-7.21h-1.43v-1.14h1.43v-1.35c0-.88.25-1.57.76-2.07.51-.51,1.14-.77,1.89-.77.41,0,.73.05.97.15v1.21Z" />
				<path d="m627.34,889.1c-.25,0-.46-.09-.64-.27-.17-.18-.26-.39-.26-.64s.09-.46.26-.64c.18-.18.39-.28.64-.28s.47.09.65.28c.18.18.27.39.27.64s-.09.46-.27.64c-.18.18-.4.27-.65.27Z" />
				<path d="m313.02,573.13v-18.15h5.16c1.57,0,2.81.38,3.73,1.15.92.77,1.38,1.77,1.38,3,0,1.03-.28,1.92-.84,2.68-.56.76-1.32,1.3-2.3,1.62v.05c1.22.14,2.2.61,2.94,1.39.73.78,1.1,1.79,1.1,3.04,0,1.55-.56,2.81-1.67,3.77-1.11.96-2.52,1.44-4.21,1.44h-5.29Zm2.13-16.22v5.86h2.18c1.16,0,2.08-.28,2.75-.84.67-.57,1-1.36,1-2.38,0-1.76-1.16-2.64-3.48-2.64h-2.44Zm0,7.77v6.53h2.89c1.25,0,2.21-.3,2.9-.89.69-.59,1.04-1.4,1.04-2.43,0-2.14-1.46-3.21-4.38-3.21h-2.44Zm21.72,8.45h-2.08v-2.02h-.05c-.9,1.55-2.23,2.33-3.99,2.33-1.29,0-2.3-.34-3.04-1.02-.73-.68-1.09-1.59-1.09-2.72,0-2.42,1.43-3.83,4.28-4.23l3.88-.54c0-2.2-.89-3.3-2.67-3.3-1.56,0-2.97.53-4.23,1.59v-2.13c1.27-.81,2.74-1.21,4.4-1.21,3.05,0,4.57,1.61,4.57,4.83v8.43Zm-2.08-6.56l-3.13.43c-.96.14-1.69.38-2.18.72-.49.34-.73.94-.73,1.81,0,.63.22,1.15.67,1.56.46.4,1.06.59,1.81.59,1.03,0,1.88-.36,2.54-1.08.67-.73,1.01-1.64,1.01-2.75v-1.29Zm12,6.43c-.49.27-1.13.4-1.94.4-2.27,0-3.4-1.27-3.4-3.8v-7.67h-2.23v-1.77h2.23v-3.16l2.08-.67v3.83h3.26v1.77h-3.26v7.3c0,.87.15,1.49.44,1.86.3.37.78.56,1.47.56.52,0,.97-.14,1.35-.43v1.77Zm13.53.13h-2.08v-7.47c0-2.7-1-4.05-3.01-4.05-1.01,0-1.86.39-2.56,1.18-.69.78-1.04,1.78-1.04,3v7.34h-2.08v-19.18h2.08v8.38h.05c1-1.64,2.41-2.45,4.25-2.45,2.92,0,4.38,1.76,4.38,5.28v7.99Z" />
				<path d="m484.53,829.27h-9.62v-18.15h9.21v1.92h-7.09v6.04h6.56v1.91h-6.56v6.35h7.49v1.92Zm13.99,0h-2.08v-7.39c0-2.75-1-4.13-3.01-4.13-1.04,0-1.9.39-2.58,1.18-.67.78-1.01,1.76-1.01,2.95v7.39h-2.08v-12.96h2.08v2.15h.05c.98-1.64,2.4-2.45,4.25-2.45,1.42,0,2.5.46,3.25,1.38.75.91,1.13,2.23,1.13,3.96v7.92Zm9.94-.13c-.49.27-1.13.4-1.94.4-2.27,0-3.4-1.27-3.4-3.8v-7.67h-2.23v-1.77h2.23v-3.16l2.08-.67v3.83h3.26v1.77h-3.26v7.3c0,.87.15,1.49.44,1.86.3.37.78.56,1.47.56.52,0,.97-.14,1.35-.43v1.77Zm9.55-10.73c-.36-.28-.89-.42-1.57-.42-.89,0-1.63.42-2.23,1.25-.59.84-.89,1.97-.89,3.42v6.61h-2.08v-12.96h2.08v2.67h.05c.3-.91.75-1.62,1.35-2.13.61-.51,1.29-.77,2.04-.77.54,0,.95.06,1.24.18v2.15Zm12.59-2.1l-5.96,15.03c-1.06,2.68-2.56,4.02-4.48,4.02-.54,0-.99-.05-1.35-.16v-1.86c.45.15.86.23,1.23.23,1.05,0,1.83-.62,2.35-1.87l1.04-2.45-5.06-12.93h2.3l3.51,9.97c.04.13.13.46.27.99h.08c.04-.2.13-.52.25-.96l3.68-10h2.15Z" />
				<path d="m281.55,207.63v-18.15h5.16c1.57,0,2.81.38,3.73,1.15.92.77,1.38,1.77,1.38,3,0,1.03-.28,1.92-.84,2.68-.56.76-1.32,1.3-2.3,1.62v.05c1.22.14,2.2.61,2.94,1.39.73.78,1.1,1.79,1.1,3.04,0,1.55-.56,2.81-1.67,3.77-1.11.96-2.52,1.44-4.21,1.44h-5.29Zm2.13-16.22v5.86h2.18c1.16,0,2.08-.28,2.75-.84.67-.57,1-1.36,1-2.38,0-1.76-1.16-2.64-3.48-2.64h-2.44Zm0,7.77v6.53h2.89c1.25,0,2.21-.3,2.9-.89.69-.59,1.04-1.4,1.04-2.43,0-2.14-1.46-3.21-4.38-3.21h-2.44Zm22.84,2.49h-9.15c.03,1.44.42,2.56,1.16,3.34.74.78,1.76,1.18,3.06,1.18,1.46,0,2.8-.48,4.02-1.44v1.95c-1.14.83-2.64,1.24-4.52,1.24s-3.27-.59-4.32-1.76c-1.05-1.18-1.57-2.84-1.57-4.97,0-2.02.57-3.66,1.71-4.92,1.15-1.27,2.57-1.91,4.26-1.91s3.01.55,3.94,1.65c.93,1.1,1.39,2.62,1.39,4.57v1.09Zm-2.13-1.76c0-1.2-.3-2.13-.87-2.8-.57-.67-1.35-1-2.37-1s-1.81.35-2.49,1.05-1.11,1.62-1.27,2.75h7Zm16.3,7.72h-2.08v-2.2h-.05c-.96,1.67-2.45,2.51-4.45,2.51-1.63,0-2.93-.58-3.91-1.73-.97-1.16-1.46-2.75-1.46-4.75,0-2.14.54-3.86,1.62-5.15s2.52-1.94,4.32-1.94,3.08.7,3.88,2.1h.05v-8.02h2.08v19.18Zm-2.08-5.86v-1.91c0-1.05-.35-1.93-1.04-2.66-.69-.73-1.57-1.09-2.63-1.09-1.27,0-2.26.46-2.99,1.39-.73.93-1.09,2.21-1.09,3.85,0,1.49.35,2.67,1.04,3.54.7.86,1.64,1.29,2.81,1.29s2.09-.42,2.81-1.25c.73-.84,1.09-1.89,1.09-3.16Zm13.01-5c-.36-.28-.89-.42-1.57-.42-.89,0-1.63.42-2.23,1.25-.59.84-.89,1.97-.89,3.42v6.61h-2.08v-12.96h2.08v2.67h.05c.3-.91.75-1.62,1.35-2.13.61-.51,1.29-.77,2.04-.77.54,0,.95.06,1.24.18v2.15Zm7.65,11.16c-1.92,0-3.45-.6-4.59-1.81-1.14-1.21-1.71-2.82-1.71-4.82,0-2.18.59-3.88,1.78-5.1,1.19-1.22,2.8-1.83,4.82-1.83s3.44.59,4.52,1.78c1.09,1.19,1.63,2.84,1.63,4.95s-.59,3.72-1.76,4.97c-1.16,1.24-2.73,1.86-4.69,1.86Zm.15-11.82c-1.33,0-2.39.46-3.16,1.37-.78.9-1.16,2.15-1.16,3.75s.39,2.75,1.18,3.63,1.83,1.33,3.15,1.33,2.37-.43,3.09-1.3c.73-.87,1.09-2.1,1.09-3.71s-.36-2.87-1.09-3.75c-.72-.88-1.75-1.32-3.09-1.32Zm15.01,11.82c-1.92,0-3.45-.6-4.59-1.81-1.14-1.21-1.71-2.82-1.71-4.82,0-2.18.59-3.88,1.78-5.1,1.19-1.22,2.8-1.83,4.82-1.83s3.44.59,4.52,1.78c1.09,1.19,1.63,2.84,1.63,4.95s-.59,3.72-1.76,4.97c-1.16,1.24-2.73,1.86-4.69,1.86Zm.15-11.82c-1.33,0-2.39.46-3.16,1.37-.78.9-1.16,2.15-1.16,3.75s.39,2.75,1.18,3.63,1.83,1.33,3.15,1.33,2.37-.43,3.09-1.3c.73-.87,1.09-2.1,1.09-3.71s-.36-2.87-1.09-3.75c-.72-.88-1.75-1.32-3.09-1.32Zm27.99,11.52h-2.08v-7.44c0-1.43-.22-2.47-.67-3.11-.44-.64-1.18-.96-2.23-.96-.89,0-1.64.4-2.27,1.21-.62.81-.92,1.78-.92,2.91v7.39h-2.08v-7.69c0-2.55-.98-3.82-2.95-3.82-.91,0-1.66.38-2.25,1.15-.59.76-.89,1.75-.89,2.97v7.39h-2.08v-12.96h2.08v2.05h.05c.92-1.57,2.26-2.35,4.02-2.35.89,0,1.66.25,2.32.75.66.49,1.11,1.13,1.35,1.94.96-1.79,2.4-2.68,4.3-2.68,2.85,0,4.28,1.76,4.28,5.28v7.99Z" />
				<path d="m291.08,230.84c0-.35.06-.7.17-1.05.11-.36.27-.69.47-.99.21-.31.46-.59.76-.84.31-.25.65-.45,1.04-.6-.57-.32-1.02-.73-1.36-1.22-.34-.5-.51-1.06-.51-1.67,0-.48.09-.93.28-1.34.19-.41.45-.77.78-1.07.33-.3.72-.53,1.18-.7.45-.17.94-.26,1.47-.26s1.03.09,1.48.26c.45.17.85.41,1.18.71.33.3.59.66.77,1.07.18.41.28.86.28,1.33,0,.61-.17,1.16-.51,1.67-.34.5-.79.91-1.34,1.22.38.15.72.35,1.02.6.3.25.55.53.75.84.21.31.37.64.48.99.11.35.17.7.17,1.05,0,.58-.1,1.1-.31,1.58-.21.48-.5.89-.88,1.23-.37.34-.83.6-1.35.79-.52.19-1.1.29-1.73.29s-1.2-.1-1.72-.29c-.52-.19-.97-.45-1.35-.79-.38-.34-.68-.75-.89-1.23-.21-.48-.31-1.01-.31-1.58Zm1.64-.13c0,.41.06.78.18,1.11.13.33.31.61.53.85.23.23.51.41.84.54.33.12.7.18,1.1.18s.74-.06,1.07-.19c.33-.13.6-.31.84-.54.24-.23.42-.52.55-.85.14-.33.2-.7.2-1.1,0-.37-.06-.71-.19-1.03-.12-.33-.3-.61-.53-.86-.23-.25-.51-.44-.84-.58-.33-.14-.69-.21-1.1-.21-.38,0-.73.07-1.06.2-.32.13-.6.31-.84.55-.23.23-.42.52-.55.85-.14.33-.2.68-.2,1.08Zm.47-6.12c0,.31.06.6.17.87.12.26.27.5.47.7.2.2.44.35.7.47.26.11.55.17.85.17s.58-.06.85-.17c.27-.12.5-.27.7-.47.2-.2.35-.44.47-.7.12-.27.17-.56.17-.87s-.06-.61-.17-.88c-.11-.27-.26-.5-.46-.7-.2-.2-.43-.35-.7-.46-.26-.12-.55-.17-.86-.17-.33,0-.62.06-.89.17-.26.12-.49.28-.69.48-.19.2-.34.43-.44.7-.1.27-.16.56-.16.87Z" />
				<rect x="301.92" y="221.32" width="1.33" height="4.11" />
				<path d="m314.1,230.33c0,.64-.1,1.24-.31,1.78-.21.54-.5,1.01-.87,1.4-.37.39-.81.7-1.32.92-.51.21-1.06.32-1.66.32-.66,0-1.26-.14-1.79-.41-.52-.28-.97-.67-1.33-1.19-.36-.52-.64-1.16-.83-1.91-.19-.75-.29-1.59-.29-2.53,0-1.15.13-2.19.38-3.12.26-.94.62-1.74,1.09-2.4.47-.67,1.04-1.18,1.7-1.55.66-.36,1.4-.54,2.22-.54.91,0,1.64.13,2.19.38v1.43c-.68-.35-1.4-.52-2.15-.52-.59,0-1.12.13-1.59.4-.47.26-.88.64-1.21,1.12-.34.48-.6,1.06-.78,1.74-.18.68-.27,1.44-.27,2.27h.04c.61-1.1,1.61-1.65,3.01-1.65.58,0,1.1.1,1.56.29.47.2.86.48,1.19.84.33.36.59.78.76,1.28s.27,1.05.27,1.66Zm-1.55.19c0-.46-.06-.87-.17-1.24-.12-.37-.29-.68-.51-.94-.21-.26-.48-.45-.8-.59-.32-.14-.68-.21-1.09-.21-.37,0-.72.07-1.04.21-.32.14-.6.33-.83.58-.23.24-.42.52-.55.85-.13.32-.19.66-.19,1.02,0,.45.06.88.19,1.28.13.39.31.74.54,1.03.23.29.51.53.83.7.33.17.68.25,1.08.25s.73-.07,1.04-.21c.31-.15.58-.35.8-.61.22-.26.39-.56.52-.92.12-.36.18-.76.18-1.2Z" />
				<path d="m317.71,221.32v4.11h-1.33v-4.11h1.33Zm3.06,0v4.11h-1.33v-4.11h1.33Z" />
				<path d="m335.85,225.09l-3.17,4.77,3.11,4.66h-1.76l-1.85-3.06c-.12-.19-.25-.43-.41-.72h-.04c-.03.06-.17.29-.43.72l-1.89,3.06h-1.74l3.21-4.62-3.07-4.8h1.76l1.82,3.22c.14.24.27.48.4.74h.04l2.36-3.96h1.67Z" />
				<path d="m350.49,227.13c0,1.21-.12,2.29-.36,3.23-.24.94-.59,1.74-1.05,2.39-.46.65-1.02,1.15-1.68,1.49-.66.34-1.42.51-2.26.51s-1.64-.15-2.3-.46v-1.45c.73.41,1.51.62,2.34.62.6,0,1.13-.12,1.59-.37.47-.25.87-.6,1.2-1.07.33-.47.57-1.05.75-1.74.17-.69.26-1.48.26-2.37h-.04c-.56,1.14-1.55,1.7-2.95,1.7-.56,0-1.08-.1-1.56-.29-.47-.2-.88-.48-1.22-.85-.34-.37-.61-.8-.8-1.31-.19-.5-.29-1.06-.29-1.67,0-.65.1-1.25.31-1.79.21-.54.51-1,.88-1.39.38-.39.83-.7,1.34-.91.52-.21,1.09-.32,1.7-.32.66,0,1.25.13,1.76.4.52.26.95.65,1.3,1.17.35.51.62,1.14.8,1.89.18.75.28,1.6.28,2.57Zm-1.63-1.35c0-.51-.07-.97-.2-1.39-.13-.42-.31-.77-.54-1.07-.23-.3-.51-.53-.84-.69-.32-.17-.67-.25-1.05-.25s-.7.07-1.01.22c-.31.14-.59.34-.82.61-.23.26-.41.57-.54.93-.13.36-.19.75-.19,1.17,0,.47.06.88.18,1.25.13.37.31.68.54.94.23.25.51.44.84.58.33.13.7.2,1.1.2.35,0,.68-.06.98-.19.31-.13.58-.31.81-.53.23-.23.41-.49.54-.79.14-.31.2-.64.2-.98Z" />
				<rect x="352.93" y="221.32" width="1.33" height="4.11" />
				<path d="m363.53,221.32v8.72h1.69v1.38h-1.69v3.1h-1.49v-3.1h-6.2v-1.31c.58-.65,1.16-1.34,1.75-2.08.59-.74,1.15-1.49,1.68-2.25.54-.76,1.04-1.52,1.49-2.27.46-.76.85-1.49,1.16-2.18h1.61Zm-5.99,8.72h4.5v-6.46c-.46.8-.9,1.52-1.31,2.15-.41.63-.8,1.21-1.18,1.72-.37.52-.72.98-1.06,1.4-.34.42-.66.81-.96,1.19Z" />
				<path d="m368.71,221.32v4.11h-1.33v-4.11h1.33Zm3.06,0v4.11h-1.33v-4.11h1.33Z" />
				<path d="m612.53,730.71h-2.96l-7.01-8.3c-.26-.31-.42-.52-.48-.63h-.05v8.93h-2.13v-18.15h2.13v8.53h.05c.12-.19.28-.39.48-.62l6.78-7.91h2.64l-7.78,8.71,8.33,9.44Zm3.17-16.25c-.37,0-.69-.13-.95-.38-.26-.25-.39-.57-.39-.96s.13-.71.39-.96c.26-.26.58-.39.95-.39s.7.13.96.39c.27.25.4.57.4.96s-.14.69-.4.95c-.26.26-.58.39-.96.39Zm1.01,16.25h-2.08v-12.96h2.08v12.96Zm10.19-.13c-.49.27-1.13.4-1.94.4-2.27,0-3.4-1.27-3.4-3.8v-7.67h-2.23v-1.77h2.23v-3.16l2.08-.67v3.83h3.26v1.77h-3.26v7.3c0,.87.15,1.49.44,1.86.3.37.78.56,1.47.56.52,0,.97-.14,1.35-.43v1.77Zm11.59-.47c-1,.6-2.18.9-3.54.9-1.85,0-3.34-.6-4.48-1.8-1.13-1.21-1.7-2.77-1.7-4.68,0-2.13.61-3.85,1.83-5.14,1.22-1.3,2.86-1.95,4.9-1.95,1.14,0,2.14.21,3.01.63v2.13c-.96-.67-1.99-1.01-3.09-1.01-1.32,0-2.41.48-3.26,1.43-.84.94-1.27,2.19-1.27,3.73s.4,2.72,1.19,3.59c.8.88,1.87,1.32,3.21,1.32,1.13,0,2.19-.38,3.19-1.13v1.97Zm13.88.59h-2.08v-7.47c0-2.7-1-4.05-3.01-4.05-1.01,0-1.86.39-2.56,1.18-.69.78-1.04,1.78-1.04,3v7.34h-2.08v-19.18h2.08v8.38h.05c1-1.64,2.41-2.45,4.25-2.45,2.92,0,4.38,1.76,4.38,5.28v7.99Zm14.31-5.96h-9.15c.03,1.44.42,2.56,1.16,3.34.74.78,1.76,1.18,3.06,1.18,1.46,0,2.8-.48,4.02-1.44v1.95c-1.14.83-2.64,1.24-4.52,1.24s-3.27-.59-4.32-1.76c-1.05-1.18-1.57-2.84-1.57-4.97,0-2.02.57-3.66,1.71-4.92,1.15-1.27,2.57-1.91,4.26-1.91s3.01.55,3.94,1.65,1.39,2.62,1.39,4.57v1.09Zm-2.13-1.76c0-1.2-.3-2.13-.87-2.8-.57-.67-1.35-1-2.37-1s-1.81.35-2.49,1.05c-.68.7-1.11,1.62-1.27,2.75h7Zm16,7.72h-2.08v-7.39c0-2.75-1-4.13-3.01-4.13-1.04,0-1.9.39-2.58,1.18-.67.78-1.01,1.76-1.01,2.95v7.39h-2.08v-12.96h2.08v2.15h.05c.98-1.64,2.4-2.45,4.25-2.45,1.42,0,2.5.46,3.25,1.38.75.91,1.13,2.23,1.13,3.96v7.92Z" />
				<path d="m532.56,335.56h-9.42v-18.15h2.13v16.22h7.29v1.92Zm3.56-16.25c-.37,0-.69-.13-.95-.38-.26-.25-.39-.57-.39-.96s.13-.71.39-.96c.26-.26.58-.39.95-.39s.7.13.96.39c.27.25.4.57.4.96s-.14.69-.4.95c-.26.26-.58.39-.96.39Zm1.01,16.25h-2.08v-12.96h2.08v12.96Zm14.37-12.96l-5.16,12.96h-2.04l-4.91-12.96h2.28l3.29,9.41c.24.69.4,1.3.46,1.81h.05c.08-.65.22-1.24.4-1.76l3.44-9.47h2.19Zm3.28-3.29c-.37,0-.69-.13-.95-.38-.26-.25-.39-.57-.39-.96s.13-.71.39-.96c.26-.26.58-.39.95-.39s.7.13.96.39c.27.25.4.57.4.96s-.14.69-.4.95c-.26.26-.58.39-.96.39Zm1.01,16.25h-2.08v-12.96h2.08v12.96Zm14.94,0h-2.08v-7.39c0-2.75-1-4.13-3.01-4.13-1.04,0-1.9.39-2.58,1.18-.67.78-1.01,1.76-1.01,2.95v7.39h-2.08v-12.96h2.08v2.15h.05c.98-1.64,2.4-2.45,4.25-2.45,1.42,0,2.5.46,3.25,1.38.75.91,1.13,2.23,1.13,3.96v7.92Zm14.96-1.04c0,4.76-2.28,7.14-6.83,7.14-1.6,0-3-.3-4.2-.91v-2.08c1.46.81,2.85,1.21,4.18,1.21,3.19,0,4.78-1.7,4.78-5.09v-1.42h-.05c-.99,1.65-2.47,2.48-4.45,2.48-1.61,0-2.91-.57-3.9-1.72-.98-1.16-1.47-2.7-1.47-4.64,0-2.2.53-3.95,1.58-5.25,1.06-1.3,2.51-1.95,4.35-1.95s3.04.7,3.88,2.1h.05v-1.8h2.08v11.92Zm-2.08-4.82v-1.91c0-1.03-.35-1.91-1.05-2.64-.69-.73-1.56-1.1-2.59-1.1-1.28,0-2.29.47-3.01,1.4-.73.93-1.09,2.23-1.09,3.91,0,1.44.35,2.6,1.04,3.47.7.86,1.62,1.29,2.77,1.29s2.11-.41,2.83-1.24c.73-.83,1.1-1.89,1.1-3.18Z" />
				<polygon points="598.07 317.41 589.37 338.57 587.43 338.57 596.11 317.41 598.07 317.41" />
				<path d="m600.18,335.56v-18.15h5.01c6.39,0,9.59,2.95,9.59,8.85,0,2.8-.89,5.05-2.67,6.76-1.77,1.7-4.15,2.54-7.12,2.54h-4.81Zm2.13-16.22v14.3h2.71c2.38,0,4.23-.64,5.56-1.91,1.32-1.27,1.99-3.08,1.99-5.42,0-4.65-2.47-6.97-7.42-6.97h-2.83Zm16.74-.03c-.37,0-.69-.13-.95-.38-.26-.25-.39-.57-.39-.96s.13-.71.39-.96c.26-.26.58-.39.95-.39s.7.13.96.39c.27.25.4.57.4.96s-.14.69-.4.95c-.26.26-.58.39-.96.39Zm1.01,16.25h-2.08v-12.96h2.08v12.96Zm14.87,0h-2.08v-7.39c0-2.75-1-4.13-3.01-4.13-1.04,0-1.9.39-2.58,1.18-.67.78-1.01,1.76-1.01,2.95v7.39h-2.08v-12.96h2.08v2.15h.05c.98-1.64,2.4-2.45,4.25-2.45,1.42,0,2.5.46,3.25,1.38.75.91,1.13,2.23,1.13,3.96v7.92Zm4.89-16.25c-.37,0-.69-.13-.95-.38-.26-.25-.39-.57-.39-.96s.13-.71.39-.96c.26-.26.58-.39.95-.39s.7.13.96.39c.27.25.4.57.4.96s-.14.69-.4.95c-.26.26-.58.39-.96.39Zm1.01,16.25h-2.08v-12.96h2.08v12.96Zm14.87,0h-2.08v-7.39c0-2.75-1-4.13-3.01-4.13-1.04,0-1.9.39-2.58,1.18-.67.78-1.01,1.76-1.01,2.95v7.39h-2.08v-12.96h2.08v2.15h.05c.98-1.64,2.4-2.45,4.25-2.45,1.42,0,2.5.46,3.25,1.38.75.91,1.13,2.23,1.13,3.96v7.92Zm14.89-1.04c0,4.76-2.28,7.14-6.83,7.14-1.6,0-3-.3-4.2-.91v-2.08c1.46.81,2.85,1.21,4.18,1.21,3.19,0,4.78-1.7,4.78-5.09v-1.42h-.05c-.99,1.65-2.47,2.48-4.45,2.48-1.61,0-2.91-.57-3.9-1.72-.98-1.16-1.47-2.7-1.47-4.64,0-2.2.53-3.95,1.58-5.25,1.06-1.3,2.51-1.95,4.35-1.95s3.04.7,3.88,2.1h.05v-1.8h2.08v11.92Zm-2.08-4.82v-1.91c0-1.03-.35-1.91-1.05-2.64-.69-.73-1.56-1.1-2.59-1.1-1.28,0-2.29.47-3.01,1.4-.73.93-1.09,2.23-1.09,3.91,0,1.44.35,2.6,1.04,3.47.7.86,1.62,1.29,2.77,1.29s2.11-.41,2.83-1.24c.73-.83,1.1-1.89,1.1-3.18Z" />
				<path d="m695.42,335.56h-2.53l-3.04-5.09c-.28-.47-.55-.87-.81-1.2-.26-.34-.53-.61-.81-.82-.27-.21-.57-.36-.89-.46-.31-.1-.67-.15-1.06-.15h-1.75v7.72h-2.13v-18.15h5.42c.79,0,1.52.1,2.19.3.67.19,1.26.49,1.75.9.5.4.89.91,1.16,1.52.28.6.42,1.3.42,2.11,0,.63-.1,1.21-.29,1.75-.19.52-.46.99-.81,1.4-.35.41-.77.77-1.27,1.06-.49.29-1.04.51-1.66.67v.05c.3.13.57.29.78.47.23.17.44.37.65.61.2.24.4.51.59.81.2.3.43.64.67,1.04l3.4,5.45Zm-10.88-16.22v6.58h2.89c.53,0,1.02-.08,1.47-.24.46-.16.85-.39,1.18-.68.33-.3.59-.67.77-1.1.19-.44.28-.93.28-1.47,0-.97-.32-1.73-.95-2.27-.62-.55-1.53-.82-2.72-.82h-2.91Zm18.43,16.53c-1.92,0-3.45-.6-4.59-1.81-1.14-1.21-1.71-2.82-1.71-4.82,0-2.18.59-3.88,1.78-5.1,1.19-1.22,2.8-1.83,4.82-1.83s3.44.59,4.52,1.78c1.09,1.19,1.63,2.84,1.63,4.95s-.59,3.72-1.76,4.97c-1.16,1.24-2.73,1.86-4.69,1.86Zm.15-11.82c-1.33,0-2.39.46-3.16,1.37-.78.9-1.16,2.15-1.16,3.75s.39,2.75,1.18,3.63c.78.89,1.83,1.33,3.15,1.33s2.37-.43,3.09-1.3c.73-.87,1.09-2.1,1.09-3.71s-.36-2.87-1.09-3.75c-.72-.88-1.75-1.32-3.09-1.32Zm14.95,11.82c-1.92,0-3.45-.6-4.59-1.81-1.14-1.21-1.71-2.82-1.71-4.82,0-2.18.59-3.88,1.78-5.1,1.19-1.22,2.8-1.83,4.82-1.83s3.44.59,4.52,1.78c1.09,1.19,1.63,2.84,1.63,4.95s-.59,3.72-1.76,4.97c-1.16,1.24-2.73,1.86-4.69,1.86Zm.15-11.82c-1.33,0-2.39.46-3.16,1.37-.78.9-1.16,2.15-1.16,3.75s.39,2.75,1.18,3.63c.78.89,1.83,1.33,3.15,1.33s2.37-.43,3.09-1.3c.73-.87,1.09-2.1,1.09-3.71s-.36-2.87-1.09-3.75c-.72-.88-1.75-1.32-3.09-1.32Zm27.94,11.52h-2.08v-7.44c0-1.43-.22-2.47-.67-3.11-.44-.64-1.18-.96-2.23-.96-.89,0-1.64.4-2.27,1.21-.62.81-.92,1.78-.92,2.91v7.39h-2.08v-7.69c0-2.55-.98-3.82-2.95-3.82-.91,0-1.66.38-2.25,1.15-.59.76-.89,1.75-.89,2.97v7.39h-2.08v-12.96h2.08v2.05h.05c.92-1.57,2.26-2.35,4.02-2.35.89,0,1.66.25,2.32.75.66.49,1.11,1.13,1.35,1.94.96-1.79,2.4-2.68,4.3-2.68,2.85,0,4.28,1.76,4.28,5.28v7.98Z" />
				<path d="m584.05,362.45h-1.51v-11.4c-.12.12-.29.25-.52.4-.22.15-.47.29-.75.44-.28.15-.57.29-.88.41-.31.13-.61.23-.9.3v-1.53c.33-.09.68-.21,1.05-.37.37-.16.74-.33,1.1-.52.36-.2.7-.4,1.02-.61.32-.21.6-.42.83-.63h.57v13.49Zm12.9-6.65c0,1.1-.1,2.08-.3,2.94-.2.85-.48,1.57-.87,2.16-.37.58-.84,1.03-1.39,1.33-.55.3-1.17.45-1.87.45-.66,0-1.25-.14-1.78-.43-.52-.29-.95-.72-1.31-1.28s-.63-1.24-.81-2.05c-.18-.82-.28-1.75-.28-2.8,0-1.15.1-2.17.29-3.06.2-.88.48-1.62.86-2.22.37-.6.84-1.05,1.39-1.35.56-.31,1.2-.46,1.91-.46,2.77,0,4.15,2.25,4.15,6.76Zm-1.55.15c0-3.76-.89-5.63-2.68-5.63-1.88,0-2.83,1.91-2.83,5.73,0,3.57.92,5.35,2.77,5.35s2.73-1.82,2.73-5.45Z" />
				<rect x="599.23" y="349.25" width="1.33" height="4.11" />
				<path d="m608.67,362.45h-1.51v-11.4c-.12.12-.29.25-.52.4-.22.15-.47.29-.75.44-.28.15-.57.29-.88.41-.31.13-.61.23-.9.3v-1.53c.33-.09.68-.21,1.05-.37.37-.16.74-.33,1.1-.52.36-.2.7-.4,1.02-.61.32-.21.6-.42.83-.63h.57v13.49Zm12.9-6.65c0,1.1-.1,2.08-.3,2.94-.2.85-.48,1.57-.87,2.16-.37.58-.84,1.03-1.39,1.33-.55.3-1.17.45-1.87.45-.66,0-1.25-.14-1.78-.43-.52-.29-.95-.72-1.31-1.28s-.63-1.24-.81-2.05c-.18-.82-.28-1.75-.28-2.8,0-1.15.1-2.17.29-3.06.2-.88.48-1.62.86-2.22.37-.6.84-1.05,1.39-1.35.56-.31,1.2-.46,1.91-.46,2.77,0,4.15,2.25,4.15,6.76Zm-1.55.15c0-3.76-.89-5.63-2.68-5.63-1.88,0-2.83,1.91-2.83,5.73,0,3.57.92,5.35,2.77,5.35s2.73-1.82,2.73-5.45Z" />
				<path d="m625.19,349.25v4.11h-1.33v-4.11h1.33Zm3.06,0v4.11h-1.33v-4.11h1.33Z" />
				<path d="m643.33,353.03l-3.17,4.77,3.11,4.66h-1.76l-1.85-3.06c-.12-.19-.25-.43-.41-.72h-.04c-.03.06-.17.29-.43.72l-1.89,3.06h-1.74l3.21-4.62-3.07-4.8h1.76l1.82,3.22c.14.24.27.48.4.74h.04l2.36-3.96h1.67Z" />
				<path d="m655.4,362.45h-1.51v-11.4c-.12.12-.29.25-.52.4-.22.15-.47.29-.75.44-.28.15-.57.29-.88.41-.31.13-.61.23-.9.3v-1.53c.33-.09.68-.21,1.05-.37.37-.16.74-.33,1.1-.52.36-.2.7-.4,1.02-.61.32-.21.6-.42.83-.63h.57v13.49Zm12.81-12.32c-.2.35-.45.79-.74,1.31-.28.52-.58,1.11-.9,1.76-.32.65-.64,1.35-.98,2.1-.33.75-.64,1.52-.93,2.32-.29.8-.54,1.61-.76,2.43-.21.82-.37,1.62-.47,2.41h-1.62c.11-.79.28-1.59.51-2.4.23-.82.49-1.63.78-2.41.29-.79.6-1.55.93-2.28.33-.73.64-1.4.95-2.02.31-.61.59-1.15.84-1.62.26-.47.46-.84.62-1.1h-6.62v-1.36h8.39v.87Z" />
				<rect x="670.59" y="349.25" width="1.33" height="4.11" />
				<path d="m682.61,355.06c0,1.21-.12,2.29-.36,3.23-.24.94-.59,1.74-1.05,2.39-.46.65-1.02,1.15-1.68,1.49-.66.34-1.42.51-2.26.51s-1.64-.15-2.3-.46v-1.44c.73.41,1.51.62,2.34.62.6,0,1.13-.12,1.59-.37.47-.25.87-.6,1.2-1.07.33-.47.57-1.05.75-1.74.17-.69.26-1.48.26-2.37h-.04c-.56,1.14-1.55,1.7-2.95,1.7-.56,0-1.08-.1-1.56-.29-.47-.2-.88-.48-1.22-.85-.34-.37-.61-.8-.8-1.31s-.29-1.06-.29-1.67c0-.65.1-1.25.31-1.79.21-.54.51-1,.88-1.39.38-.39.83-.7,1.34-.91.52-.21,1.09-.32,1.7-.32.66,0,1.25.13,1.76.4.52.26.95.65,1.3,1.17.35.51.62,1.14.8,1.89.18.75.28,1.6.28,2.57Zm-1.63-1.35c0-.51-.07-.97-.2-1.39-.13-.42-.31-.77-.54-1.07-.23-.3-.51-.53-.84-.69-.32-.17-.67-.25-1.05-.25s-.7.07-1.01.22c-.31.14-.59.34-.82.61-.23.26-.41.57-.54.93-.13.36-.19.75-.19,1.17,0,.47.06.88.18,1.25.13.37.31.68.54.94.23.25.51.44.84.58.33.14.7.2,1.1.2.35,0,.68-.06.98-.19.31-.13.58-.31.81-.53.23-.23.41-.49.54-.79.13-.31.2-.64.2-.98Z" />
				<path d="m686.37,349.25v4.11h-1.33v-4.11h1.33Zm3.06,0v4.11h-1.33v-4.11h1.33Z" />
				<path d="m372.55,852.98l-2.98,10.57h-1.45l-2.17-7.72c-.09-.33-.15-.69-.17-1.08h-.03c-.03.36-.09.72-.19,1.06l-2.19,7.74h-1.44l-3.09-10.57h1.36l2.25,8.11c.09.34.15.69.18,1.06h.04c.02-.26.1-.61.23-1.06l2.34-8.11h1.19l2.24,8.16c.08.28.14.61.18.99h.03c.02-.26.09-.59.2-1.02l2.16-8.13h1.34Z" />
				<polygon points="378.71 852.98 373.64 865.3 372.51 865.3 377.57 852.98 378.71 852.98" />
				<path d="m379.94,863.54v-10.57h2.92c3.72,0,5.59,1.72,5.59,5.15,0,1.63-.52,2.94-1.55,3.93-1.03.99-2.41,1.48-4.15,1.48h-2.8Zm1.24-9.45v8.33h1.58c1.39,0,2.46-.37,3.23-1.11.77-.74,1.16-1.79,1.16-3.15,0-2.71-1.44-4.06-4.32-4.06h-1.65Z" />
			</g>
		</g>
	)
}

export default PlanI
